<template>
  <div id="non-printable-section" :class="{'tile-view full-height grey-back':!$root.dataObj.tableView}" :data-no-translate="(reportId==801 || reportId==802 || reportId==803 || reportId==804 || $route.query.subreport) ? '' : null">
      <v-toolbar flat fixed>
          <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>{{$route.query.reporttitle  ? $route.query.reporttitle : $root.dataObj.reportTitle}}</v-toolbar-title>
<!--             <v-toolbar-title>Reports</v-toolbar-title> -->
          <v-spacer></v-spacer>

          <v-btn icon @click="fn_changeView" v-if="$root.dataObj.tileContent && $route.params.reportid!=803 && $route.params.reportid!=802 && $route.params.reportid!=801 && !$route.query.subreport"><v-icon>{{$root.dataObj.tableView ? 'view_list' : 'grid_on'}}</v-icon></v-btn>
          
          <v-btn icon @click="filter_sheet=true" v-if="!$root.dataObj.hideFilterBtn">
            <v-icon>filter_list</v-icon>
            <span style="font-size: 48px;position: absolute;bottom: -12px;right: -2px;color: #4b77be;" v-if="$root.reportFilterObj && Object.keys($root.reportFilterObj).length">&bull;</span>
          </v-btn>

          <v-menu content-class="action_menu" z-index="99" origin="top left">
              <v-btn slot="activator" icon dark><v-icon>more_vert</v-icon></v-btn>
              <v-list class="small-action-tile" nopadding>

                  <v-list-tile id="exportExcelBtn">
                    <v-list-tile-action><img src="../../assets/icon_excel.svg" style="width:24px;opacity:0.6" alt=""></v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Export Excel</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile v-if="reportId==801" @click="fn_getGSTPortalData">
                    <v-list-tile-action><img src="../../assets/icon_excel.svg" style="width:24px;opacity:0.6" alt=""></v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Export Excel For GST Portal</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile small-action-tile @click="fn_action('pdf')">
                    <v-list-tile-action><img src="../../assets/icon_pdf_light.svg" style="width:24px;opacity:0.6" alt=""></v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Export PDF</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile small-action-tile @click="fn_action('print')">
                    <v-list-tile-action><v-icon>print</v-icon></v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Print</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-list-tile small-action-tile @click="fn_openDialogShareOptions">
                    <v-list-tile-action><v-icon>share</v-icon></v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>Share</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

              </v-list>
          </v-menu>

      </v-toolbar>

      <div :class="'report_'+reportId" :data-no-translate="(reportId==801 || reportId==802 || reportId==803 || reportId==804 || $route.query.subreport) ? '' : null">
          <report-template-container ref="ref_reportTemplateContainer" :reportId="reportId" :propsObj="$root.dataObj" :openDialogAndroid="fn_openDialogAndroid" :reportType="fn_getReportType()" :getReportItemDetails="fn_getReportItemDetails" :openDatePicker="fn_openDatePicker" :reportFilterObj="$root.reportFilterObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails" :tableView="$root.dataObj.tableView" :openLinkedAccount="fn_openLinkedAccount" :getSubReportData="fn_getSubReportData" :subReportData="$root.dataObj.subReportData" :periods="periods" :selectPeriod="fn_selectPeriod" :openDialogCustomDates="fn_openDialogCustomDates" :getSubReportData2="fn_getSubReportData2" :subReportData2="$root.dataObj.subReportData2" :periodsLastDays="periodsLastDays" :selectDays="fn_selectDays"></report-template-container>
      </div>


      <v-snackbar v-model="snackbar">
        File downloaded!
        <v-btn flat color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
      </v-snackbar>

      <!-- <dialog-filter ref="ref_dialogFilter"></dialog-filter> -->
      <dialog-period-selection ref="ref_dialogCustomPeriod" title="Select Period" :openDatePicker="fn_openDatePicker" :startDate="selectedStartDate" :endDate="selectedEndDate" :actionMethod="fn_updateCustomDates" :closeDialog="fn_closeDialog"></dialog-period-selection>

      <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

      <dialog-share-options ref="ref_dialogShareOptions" :sharePdf="fn_action"></dialog-share-options>
      <dialog-linked-accounts ref="ref_dialogLinkedAccounts" :linkedAccounts="linkedAccounts" :getLinkedAccountDetails="fn_getLinkedAccountDetails"></dialog-linked-accounts>
      <!-- <dialog-gstr-report ref="ref_gstrSubReport" :reportData="subReportData" :getSubReportData2="fn_getSubReportData2"></dialog-gstr-report>
      <dialog-gstr-report-2 ref="ref_gstrSubReport2" :reportData="subReportData2"></dialog-gstr-report-2> -->
      <dialog-comp-tax-rate ref="ref_dialogCompTaxRate" :openDialogTaxRateList="fn_openDialogTaxRateList"></dialog-comp-tax-rate>
      <dialog-tax-rate-list ref="ref_dialogTaxRateList" :taxRates="compTaxRateList" :selectedTaxRate="compTaxRate.value" :updateTaxRate="fn_updateTaxRate"></dialog-tax-rate-list>

      <dialog-month-filter ref="ref_dialogMonthFilter" :selectPeriod="fn_selectPeriod"></dialog-month-filter>
      <dialog-quarter-filter ref="ref_dialogQuarterFilter" :selectPeriod="fn_selectPeriod"></dialog-quarter-filter>
      <dialog-fy-filter ref="ref_dialogFiscalYearFilter" :selectPeriod="fn_selectPeriod"></dialog-fy-filter>

      <dialog-profit-loss-details ref="ref_dialogProfitLossDetails" :data="itemWiseProfitLossData" v-if="itemWiseProfitLossData"></dialog-profit-loss-details>
      <v-bottom-sheet v-model="bottomSheet">
          <v-card v-if="detailReportObj" class="report-details-card">
            <!-- <v-card-title primary-title>{{detailReportObj.reportTitle}}</v-card-title> -->
            <v-card-text nopadding>
              <transaction-details ref="ref_transactionDetails" :propsObj="detailReportObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails"></transaction-details>
            </v-card-text>
          </v-card>
      </v-bottom-sheet>

      <v-bottom-sheet v-model="filter_sheet">
        <filter-sheet ref="ref_filter" :applyFilter="fn_applyFilter" :openFilterDialog="fn_openFilterDialog" :closeFilters="fn_closeFilters" :closeDialog="fn_closeDialog" :propsObj="$root.dataObj" :openDialogAndroid="fn_openDialogAndroid" :openDatePicker="fn_openDatePicker" :clearAllFilters="fn_clearAllFilters" :openDialogTaxRateList="fn_openDialogTaxRateList"></filter-sheet>
        <!-- <filter-sheet ref="ref_filter" :getReportData="fn_getReportData" :openFilterDialog="fn_openFilterDialog" :closeFilters="fn_closeFilters" :closeDialog="fn_closeDialog" :propsObj="$root.dataObj" :openDialogAndroid="fn_openDialogAndroid" :openDatePicker="fn_openDatePicker" :clearAllFilters="fn_clearAllFilters" :openDialogTaxRateList="fn_openDialogTaxRateList"></filter-sheet> -->
      </v-bottom-sheet>

      <!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
  </div>
</template>


<script>

const dialogjs =  require('../masters/forms/dialog').dialogjs;
import reportTemplateContainer from './report_template_container'
import dialogShareOptions from './dialogs/dialog_share_options'

import dialogPeriodSelection from '../dialogs/dialog_period_selection'
import dialogDatepicker from './dialogs/dialog_datepicker'
import dialogFyFilter from '../dialogs/dialog_filter_fiscalyear'

import dialogLinkedAccounts from './dialogs/dialog_linked_accounts'
// import dialogGstrReport from './dialogs/dialog_gstr_report'
// import dialogGstrReport2 from './dialogs/dialog_gstr_report_2'
import dialogCompTaxRate from './dialogs/dialog_comp_tax_rate'
import dialogTaxRateList from './dialogs/dialog_tax_rate_list'
import dialogMonthFilter from '../dialogs/dialog_filter_months'
import dialogQuarterFilter from '../dialogs/dialog_filter_quarter'
import dialogProfitLossDetails from './dialogs/dialog_profit_loss_detail'
import transactionDetails from './report_templates/transaction_details'
import {reportTableMixin} from './report_table_mixin.js'
import filter from './report_templates/filter'

import work from 'webworkify-webpack'

let dataConfig = null

const listIdObject = require('../../config.js').configs.mastersPredefinedLists;
const accountGroupIds = require('../../config.js').configs.accountGroupIds;
const transactionTypes = require('../../config.js').configs.transactionTypes
const transactionForms = require('../../config.js').configs.transactionForms
const reportList = require('../../config.js').configs.reportList;
const transactionTypeForms = require('../../config.js').configs.transactionTypeForms;

// import dialogPermission from '../dialogs/dialog_permission';

export default {
mixins: [reportTableMixin],
data(){
  return{
      reportId:null,
      // dataObj:{
      //   reportTitle:null,
      //   itemName:null,
      //   itemId:null,
      //   itemLabel:null,
      //   startDate:new Date(), 
      //   endDate:new Date(), 
      //   reportData:{"headerRow":null},
      //   columns:null,
      //   footerColumns:null,
      //   detailReportId:null,
      //   openView:false
      // },

      detailReportObj:null,
      dialogStorageId:null,
      snackbar:false,
      snackbar_msg:null,
      bottomSheet:false,
      dateType:null,
      selectedDate:null,
      // reportType:null,
      filter_sheet:false,
      // $root.reportFilterObj:{},
      shareExcel:false,
      tileViewDetailSheet:false,
      tileViewTotalSheet:false,
      linkedAccounts:null,
      subReportData:null,
      subReportData2:null,
      isGoBack:false,
      compTaxRateList:null,
      compTaxRate:{type:null, value:null},
      // selectedPeriod:null,
      periods:[
        {"title":"Today", "value":"currentDate"},
        {"title":"Yesterday", "value":"previousDate"},
        {"title":"This Month", "value":"month"},
        {"title":"Previous Month", "value":"previousMonth"},
        {"title":"Select Month", "value":"M"},
        {"title":"This Quarter", "value":"quarter"},
        {"title":"Select Quarter", "value":"Q"},
        {"title":"This Fiscal Year", "value":"year"},
        {"title":"Select Fiscal Year", "value":"FY"},
        {"title":"All Time", "value":"alltime"},
        {"title":"Custom", "value":null},
      ],
      selectedStartDate:null,
      selectedEndDate:null,
      itemWiseProfitLossData:null,

      periodsLastDays:[{'title':'7 Days', "value":7}, {'title':'15 Days', "value":15}, {'title':'30 Days', "value":30}, {'title':'45 Days', "value":45}, {'title':'90 Days', "value":90}],
      // partyGroupTypeId:null
  }
},
components:{
  'report-template-container': reportTemplateContainer,
  'dialog-share-options': dialogShareOptions,
  'dialog-period-selection':dialogPeriodSelection,
  'dialog-datepicker': dialogDatepicker,
  'transaction-details': transactionDetails,
  'filter-sheet':filter,
  'dialog-linked-accounts':dialogLinkedAccounts,
  // 'dialog-gstr-report':dialogGstrReport,
  // 'dialog-gstr-report-2':dialogGstrReport2,
  'dialog-comp-tax-rate':dialogCompTaxRate,
  'dialog-tax-rate-list':dialogTaxRateList,
  // 'dialog-permission': dialogPermission,
  'dialog-month-filter': dialogMonthFilter,
  'dialog-quarter-filter': dialogQuarterFilter,
  'dialog-profit-loss-details':dialogProfitLossDetails,
  'dialog-fy-filter':dialogFyFilter
},
methods:{

fn_getReportType: function(){
  // if(this.$refs['ref_gstrSubReport'] && this.$refs['ref_gstrSubReport'].dialog_gst_report){
  if(this.$route.query.subreport){
    return 'gstrsubreport';
  }
  else{
    return this.$root.dataObj.reportType;
  }
},

  fn_postReportPreferences: function(reportId, valueObj){
    let self = this;
    let postObj = {};
    if(this.$root.dataObj.reportPreferences && this.$root.dataObj.reportPreferences.reportPreferenceId){
      postObj.reportPreferenceId = this.$root.dataObj.reportPreferences.reportPreferenceId;
    }
    else{
      postObj.reportPreferenceId = this.guid();
    }
    
    postObj.reportId = reportId.toString();
    postObj.userId = null;
    postObj.value = JSON.stringify(valueObj);

    this.postData('ReportPreference', postObj, 
      {
        onSuccess: function(response){
          console.log(response);
          self.$root.dataObj.reportPreferences = {};
          self.$root.dataObj.reportPreferences.reportPreferenceId = postObj.reportPreferenceId;
          self.$root.dataObj.reportPreferences.reportId = postObj.reportId;
          self.$root.dataObj.reportPreferences.userId = postObj.userId;
          self.$root.dataObj.reportPreferences.value = valueObj;
          // self.$refs['ref_filter'].fn_updateItem(null, self.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
          self.fn_updateFilterItem(null, self.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
          // self.fn_getReportData();

        },
        onError: function(error){
            console.log(error);
        }
      }
    );
  },

  fn_getReportPreferences: function(reportId, itemId, itemName, to){
    let self = this;
    let reportIdStr = reportId.toString();
    this.getData('ReportPreference', reportIdStr, 
      {
        onSuccess: function(response){
          console.log(response);
          self.$root.dataObj.reportPreferences = JSON.parse(response);
          if(self.$root.dataObj.reportPreferences && self.$root.dataObj.reportPreferences.value){
            self.$root.dataObj.reportPreferences.value = JSON.parse(self.$root.dataObj.reportPreferences.value);
            self.compTaxRate.value = self.$root.dataObj.reportPreferences.value.taxRate;
            self.compTaxRate.type = self.$root.dataObj.reportPreferences.value.type;
          }
          else{
            self.$root.dataObj.reportPreferences = null;
          }

          self.fn_initializeData(itemId, itemName, to);
        },
        onError: function(error){
            console.log(error);
        }
      }
    );
  },

  fn_getSubReportData: function(subReportId){
    if(!subReportId || subReportId == "GSTR2ADVANCE" || subReportId == "GSTR2ADJSUTMENT"){
      return;
    }

    if(this.$route.params.reportid == 803){
      this.fn_generateDataForGSTR3B_subReport(subReportId);
      return;
    }

    let subReportConfig = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(subReportId)));

  //   this.fn_openGstrSubReport(subReportId, subReportConfig.reportTitle, 1);

    this.$root.dataObj.subReportData = {};
    this.$root.dataObj.subReportData.reportTitle = subReportConfig.reportTitle;

    console.log(JSON.stringify(subReportConfig));

    let filterObject = {};
    filterObject.gstrReportId = subReportId;
    filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
    filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

    filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
    filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

    let self = this;
    this.getReportData('GstrSubReport', this.$root.CurrentBusiness.StateID, filterObject,{
      onSuccess: function(response){
        console.log(response);
        self.$root.dataObj.subReportData = JSON.parse(response);
        self.$root.dataObj.subReportData.reportTitle = subReportConfig.reportTitle;
        self.$root.dataObj.subReportData.headerRow = subReportConfig.headerRow;
        self.$root.dataObj.subReportData.headerRowArr = subReportConfig.headerRowTableHeaders;
        self.$root.dataObj.subReportData.columns = subReportConfig.columns;
        self.$root.dataObj.subReportData.internalHeaderRow = subReportConfig.internalHeaderRow;
        self.$root.dataObj.subReportData.internalHeaderRowArr = subReportConfig.internalHeaderRowArr;
        self.$root.dataObj.subReportData.internalColumns = subReportConfig.internalColumns;
      //   self.$root.dataObj.subReportData.startDate = self.$route.query.startDate;
      //   self.$root.dataObj.subReportData.endDate = self.$route.query.endDate;
        console.log(JSON.stringify(self.$root.dataObj.subReportData));
        self.fn_openGstrSubReport(subReportId, subReportConfig.reportTitle, 1);
      //   self.fn_openGstrSubReport();
      }, 
      onError: function(error){
        console.log(error);
        self.hideLoading();
      }

    });
  },

  fn_getSubReportData2: function(subReportId){

    let subReportConfig = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(subReportId)));

    console.log(JSON.stringify(subReportConfig));

    this.fn_openGstrSubReport(subReportId, subReportConfig.reportTitle, 2);

    let filterObject = {};
    filterObject.gstrReportId = subReportId;
    filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
    filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

    filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
    filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

    let self = this;
    this.getReportData('GstrSubReport', this.$root.CurrentBusiness.StateID, filterObject,{
      onSuccess: function(response){
        console.log(response);
        self.$root.dataObj.subReportData2 = JSON.parse(response);
        self.$root.dataObj.subReportData2.reportTitle = subReportConfig.reportTitle;
        self.$root.dataObj.subReportData2.headerRow = subReportConfig.headerRow;
        self.$root.dataObj.subReportData2.headerRowArr = subReportConfig.headerRowTableHeaders;
        self.$root.dataObj.subReportData2.columns = subReportConfig.columns;
        self.$root.dataObj.subReportData2.internalHeaderRow = subReportConfig.internalHeaderRow;
        self.$root.dataObj.subReportData2.internalHeaderRowArr = subReportConfig.internalHeaderRowArr;
        self.$root.dataObj.subReportData2.internalColumns = subReportConfig.internalColumns;
        self.$root.dataObj.subReportData2.startDate = self.$route.query.startDate;
        self.$root.dataObj.subReportData2.endDate = self.$route.query.endDate;
        console.log(JSON.stringify(self.$root.dataObj.subReportData2));
      //   self.fn_openGstrSubReport2();
      }, 
      onError: function(error){
        console.log(error);
        self.hideLoading();
      }

    });
  },

  fn_generateDataForGSTR3B_subReport: function(item){

    console.log(item);

    this.$root.dataObj.subReportData = {};
    this.$root.dataObj.subReportData.data = {};
    this.$root.dataObj.subReportData.data.detailRows = [];

    // this.$root.dataObj.subReportData = item.subreportData;
    this.$root.dataObj.subReportData.data.detailRows = this.$root.dataObj.reportData.detailRows.filter(subReportItem=>{
      if(item.section == '3.2'){
        return subReportItem.section == item.section && !subReportItem.mainRow && (subReportItem.cols.otherTax && subReportItem.cols.otherTax.items && subReportItem.cols.otherTax.items.length);
      }
      else{
        return subReportItem.section == item.section && !subReportItem.mainRow
      }
    })

    this.$root.dataObj.subReportData.reportTitle = item.title;

    if(item.section == '3.1'){

      this.$root.dataObj.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "taxableValue":"Total Taxable Value", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
      this.$root.dataObj.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Total Taxable Value","type":"number"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
      this.$root.dataObj.subReportData.columns = ["natureOfSupplies", "taxableValue", "igst", "cgst", "sgst", "cess"];
    }
    else if(item.section == '3.2'){
      this.$root.dataObj.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies"};
      this.$root.dataObj.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}];
      this.$root.dataObj.subReportData.columns = ["natureOfSupplies"];

      this.$root.dataObj.subReportData.internalHeaderRow = {"placeOfSupply":"Place of Supply (State/UT)", "taxableValue":"Total Taxable Value", "igst":"Amount of Tax"};
      this.$root.dataObj.subReportData.internalHeaderRowArr = [{"headerName":"Place of Supply (State/UT)","type":"string"},{"headerName":"Total Taxable Value","type":"number"},{"headerName":"Amount of Tax","type":"number"}];
      this.$root.dataObj.subReportData.internalColumns = ["placeOfSupply", "taxableValue", "igst"];
    }
    else if(item.section == '4'){
      this.$root.dataObj.subReportData.headerRow = {"natureOfSupplies":"Details", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
      this.$root.dataObj.subReportData.headerRowArr = [{"headerName":"Details","type":"string"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
      this.$root.dataObj.subReportData.columns = ["natureOfSupplies", "igst", "cgst", "sgst", "cess"];
    }
    else if(item.section == '5'){
      this.$root.dataObj.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "interStateAmount":"Inter-State Supplies", "intraStateAmount":"Intra-State Supplies"};
      this.$root.dataObj.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Inter-State Supplies","type":"number"}, {"headerName":"Intra-State Supplies","type":"number"}];
      this.$root.dataObj.subReportData.columns = ["natureOfSupplies", "interStateAmount", "intraStateAmount"];
    }
    if(item.section == '5.1'){
      this.$root.dataObj.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
      this.$root.dataObj.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
      this.$root.dataObj.subReportData.columns = ["taxableValue", "igst", "cgst", "sgst", "cess"];
    }

    console.log(JSON.stringify(this.$root.dataObj.subReportData));

    this.fn_openGstrSubReport(item.subReportId, item.title, 1);
  //   this.fn_openGstrSubReport();

    // self.$root.dataObj.subReportData = JSON.parse(response);
    // self.$root.dataObj.subReportData.reportTitle = subReportConfig.reportTitle;
    // self.$root.dataObj.subReportData.headerRow = subReportConfig.headerRow;
    // self.$root.dataObj.subReportData.headerRowArr = subReportConfig.headerRowTableHeaders;
    // self.$root.dataObj.subReportData.columns = subReportConfig.columns;

    // reportTitle:"Summary For HSN(12)",
    // headerRow:{"hsnCode":"HSN", "description":"Description", "unitQtyCode":"UQC", "qty":"Total Quantity", "value":"Total Value (₹)", "taxableValue":"Total Taxable Value (₹)", "igst":"Integrated Tax (₹)", "cgst":"Central Tax (₹)", "stgst":"State/UT Tax (₹)", "cess":"CESS (₹)"},

    // headerRowTableHeaders:[{"headerName":"HSN","type":"string"},{"headerName":"Description","type":"string"},{"headerName":"UQC","type":"string"},{"headerName":"Total Quantity","type":"number"},{"headerName":"Total Value (₹)","type":"number"},{"headerName":"Total Taxable Value (₹)","type":"number"},{"headerName":"Integrated Tax (₹)","type":"number"},{"headerName":"Central Tax (₹)","type":"number"},{"headerName":"State/UT Tax (₹)","type":"number"},{"headerName":"CESS (₹)","type":"number"}],

    // columns:['hsnCode', 'description', 'unitQtyCode', 'qty', 'value', 'taxableValue', 'igst', 'cgst', 'stgst', 'cess'],

  },

  fn_openGstrSubReport: function(subReportId, title, level){
      //   this.fn_openDialogWeb('web', 'GstrSubReport', 'ref_gstrSubReport');
      let startDate = this.$moment(this.$root.dataObj.startDate).startOf('day').toISOString();
      let endDate = this.$moment(this.$root.dataObj.endDate).endOf('day').toISOString();
      this.$router.push({path:"/reports/"+this.$root.CurrentBusiness.BusinessID+"/"+subReportId, query:{subreport:level, reporttitle:title, startDate:startDate, endDate:endDate}});
  },

  // fn_openGstrSubReport2: function(){
  //   this.fn_openDialogWeb('web', 'GstrSubReport2', 'ref_gstrSubReport2');
  // },

  fn_openLinkedAccount: function(linkedAccounts){
    if(!linkedAccounts){
      return
    }
    this.linkedAccounts = linkedAccounts;
    this.fn_openDialogWeb('web', 'LinkedAccounts', 'ref_dialogLinkedAccounts');
  },

  fn_getLinkedAccountDetails: function(item){
    this.fn_closeDialog();
    let self = this;
    setTimeout(function(){
      self.$refs['ref_reportTemplateContainer'].$refs['ref_generalReport'].fn_getDetails(item, true);
    },300)
  },

  fn_openDialogShareOptions: function(){
      this.fn_openDialogWeb('web', 'Filter', 'ref_dialogShareOptions');
  },

  fn_closeFilters: function(){
    this.filter_sheet = false;
  },

  fn_openDialogCustomDates: function(){
      this.selectedStartDate = this.$root.dataObj.startDate;
      this.selectedEndDate = this.$root.dataObj.endDate;
      this.fn_openDialogWeb('web', 'CustomPeriod', 'ref_dialogCustomPeriod');
  },

  fn_openDatePicker: function (type, date) {
    let self = this;
    this.dateType = type;
    this.selectedDate = date;
    setTimeout(function () {
      self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
    })
  },

  // fn_updateDate: function (value) {
  //   this.fn_closeDialog();

  //   if(this.dateType=="start"){
  //     this.$root.dataObj.startDate = value;
  //   }
  //   else if(this.dateType=="end"){
  //     this.$root.dataObj.endDate = value;
  //   }

  //   this.$root.dataObj.selectedPeriod = null;

  //   let localDateObj = {};
  //   localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
  //   localDateObj.endDate = this.$root.dataObj.endDate;
  //   localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
  //   localStorage.setItem('report_period_'+this.$route.params.reportid, JSON.stringify(localDateObj));

  //   this.fn_getReportData();

  //   let self = this;
  //   setTimeout(function(){
  //     self.$refs['ref_dialogDatePicker'].disableBtn = false;
  //   }, 1000);
  // },

  fn_updateDate: function (value) {
    this.fn_closeDialog();

    if(this.dateType=="start"){
      this.selectedStartDate = value;
    }
    else if(this.dateType=="end"){
      this.selectedEndDate = value;
    }

    if(this.$root.dataObj.periodLabel == 'As On'){
      this.fn_updateCustomDates();
    }

    let self = this;
    setTimeout(function(){
      self.$refs['ref_dialogDatePicker'].disableBtn = false;
    }, 1000);

    // this.dialog_datepicker = false;

    // this.fn_getDashboardData();
  },

  fn_updateCustomDates: function(){
    this.selectedStartDate ? this.$root.dataObj.startDate = this.selectedStartDate : '';
    this.selectedEndDate ? this.$root.dataObj.endDate = this.selectedEndDate : '';
    this.fn_closeDialog();
    this.$root.dataObj.selectedPeriod = null;

    let localDateObj = {};
    localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
    localDateObj.endDate = this.$root.dataObj.endDate;
    localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
    localStorage.setItem('report_period_'+this.$route.params.reportid, JSON.stringify(localDateObj));

    this.$root.dataObj.selectedPeriod = "Custom";
    console.log('custom dates');
    this.fn_getReportData();
  },

  fn_openDialogMonthFilter: function(){
    this.fn_openDialogWeb('web', 'MonthFilter', 'ref_dialogMonthFilter');
  },

  fn_openDialogQuarterFilter: function(){
    this.fn_openDialogWeb('web', 'QuarterFilter', 'ref_dialogQuarterFilter');
  },

  fn_selectPeriod: function(type, month, year){
    if(!type){
      this.fn_openDialogCustomDates();
      return;
    }

    if(type=='M'){
      this.fn_openDialogMonthFilter();
    }
    else if(type=='Q'){
      this.fn_openDialogQuarterFilter();
    }
    else if(type=='FY'){
      this.fn_openDialogFyfilter();
    }
    else{
      this.fn_closeDialog();

      let previousDateSelected = false;

      // Date validation if selected before opening date
      if(type == "previousMonth"){
        let now = new Date();
        let previousMonthDate = new Date(now.getFullYear(), now.getMonth(), 0);
        if(previousMonthDate.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
          previousDateSelected = true;
        }
      }

      if(type == "previousDate"){
        let now = new Date();
        let yesterday = new Date(now.setDate(now.getDate() - 1));
        if(yesterday.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
          previousDateSelected = true;
        }
      }

      if(previousDateSelected){
        this.showToast("Not Applicable");
        return;
      }
      // Date validation end if selected before opening date
      
      let dateObj = this.fn_getTimeSpan(type, month, year);

      this.$root.dataObj.startDate = dateObj.startDate;
      this.$root.dataObj.endDate = dateObj.endDate;

      let localDateObj = {};
      // localDateObj.startDate = this.$root.dataObj.startDate ? new Date(this.$root.dataObj.startDate) : null;
      localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
      // localDateObj.endDate = new Date(this.$root.dataObj.endDate);
      localDateObj.endDate = this.$root.dataObj.endDate;
      localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
      localStorage.setItem('report_period_'+this.$route.params.reportid, JSON.stringify(localDateObj));
      console.log('period');
      this.fn_getReportData();
    }
  },

  fn_selectDays: function(item){
    this.$root.dataObj.selectedPeriod = item.title;
    let date = new Date();
    this.$root.dataObj.endDate = new Date(date.setDate(date.getDate() + item.value));
    console.log('select days');
    this.fn_getReportData();
  },

  fn_getReportData: function(filterObj){
    console.log('get report');
      this.showLoading('Preparing report...');
      let filterObject = {};

      !this.reportId ? this.reportId = this.$route.params.reportid : '';

      // filterObj ? this.$root.reportFilterObj = filterObj : '';
      if(filterObj){
        this.$root.reportFilterObj = filterObj;
      }
      // else if(localStorage.getItem("report_filter_"+this.reportId)){
      //  this.$root.reportFilterObj = JSON.parse(localStorage.getItem("report_filter_"+this.reportId)); 
      // }

      filterObject.reportId = this.reportId;

      // if(localStorage.getItem('period_'+this.reportId)){
      //   let periodObj = JSON.parse(localStorage.getItem('period_'+this.reportId));
      //   this.$root.dataObj.startDate = periodObj.startDate;
      //   this.$root.dataObj.endDate = periodObj.endDate;
      // }

      // filterObject.startDate = new Date(this.$root.dataObj.startDate);
      // filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');
      // filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');
      filterObject.startDate = this.$root.dataObj.startDate ? this.$moment(this.$root.dataObj.startDate).startOf('day') : null;
      filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

      filterObject.startDate = filterObject.startDate ? this.$root.fn_getLocalDateFormat(filterObject.startDate) : null;
      filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

      if(this.reportId==304 || this.reportId==404){
        filterObject.transactionListId = this.reportId==304 ? [transactionTypes.deliveryChallan.id] : [transactionTypes.purchaseChallan.id];
        !this.$root.reportFilterObj.status ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":"All"} : '';
      }
      else if(this.reportId==305 || this.reportId==405 || this.reportId==311 || this.reportId==418){
        filterObject.transactionListId = this.reportId==305 || this.reportId==311 ? [transactionTypes.order.id] : [transactionTypes.purchaseOrder.id];
        !this.$root.reportFilterObj.status ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":"All"} : '';
      }
      else if(this.reportId==503){
        !this.$root.reportFilterObj.groupTypeId ? this.$root.reportFilterObj.groupTypeId = {"id":null, "name":"Type", "value":"All"} : '';
      }
      else if(this.reportId==406){
        filterObject.accountGroups = [accountGroupIds.purchaseAccount.id];
      }
      else if(this.reportId==412 || this.reportId==413 || this.reportId==414){
        filterObject.transactionListId = [20005];
      }

      // if(this.reportId == 804 && this.$root.dataObj.reportPreferences && this.$root.dataObj.reportPreferences.value){
      //   filterObject.taxRate = this.$root.dataObj.reportPreferences.value;
      // }

      //Advance Filters
      if(Object.keys(this.$root.reportFilterObj).length){
        if(this.$root.reportFilterObj.party)
          filterObject.partyId = this.$root.reportFilterObj.party.id;
        if(this.$root.reportFilterObj.product)
          filterObject.productId = this.$root.reportFilterObj.product.id;
        if(this.$root.reportFilterObj.brand)
          filterObject.brandId = this.$root.reportFilterObj.brand.id;
        if(this.$root.reportFilterObj.category)
          filterObject.categoryId = this.$root.reportFilterObj.category.id;
        if(this.$root.reportFilterObj.taxType)
          filterObject.taxTypeId = this.$root.reportFilterObj.taxType.id;
        if(this.$root.reportFilterObj.transactionTypeForm)
          filterObject.transactionTypeFormId = this.$root.reportFilterObj.transactionTypeForm.id;
        if(this.$root.reportFilterObj.accountGroup)
          filterObject.accountGroups = [this.$root.reportFilterObj.accountGroup.id];
        if(this.$root.reportFilterObj.prescriber)
          filterObject.prescribedToId = this.$root.reportFilterObj.prescriber.id;
        if(this.$root.reportFilterObj.salesman)
          filterObject.salesmanId = this.$root.reportFilterObj.salesman.id;
        if(this.$root.reportFilterObj.broker)
          filterObject.brokerId = this.$root.reportFilterObj.broker.id;
        if(this.$root.reportFilterObj.status)
          filterObject.status = this.$root.reportFilterObj.status.value;
        if(this.$root.reportFilterObj.groupTypeId)
          filterObject.groupTypeId = this.$root.reportFilterObj.groupTypeId.value == 'Receivables' ? 101 : this.$root.reportFilterObj.groupTypeId.value == 'Payables' ? 102 : null;
        if(this.$root.reportFilterObj.taxRate)
          filterObject.taxRate = this.$root.reportFilterObj.taxRate.value;
        if(this.$root.reportFilterObj.showOutOfStock)
          filterObject.showOutOfStock = this.$root.reportFilterObj.showOutOfStock.value;
        if(this.$root.reportFilterObj.dueDays)
          filterObject.dueDays = this.$root.reportFilterObj.dueDays.value;
        if(this.$root.reportFilterObj.showMSME)
          filterObject.showMSME = this.$root.reportFilterObj.showMSME.value;
        if(this.$root.reportFilterObj.showAllBatch)
          filterObject.showExpireBatch = this.$root.reportFilterObj.showAllBatch.value;
        if(this.$root.reportFilterObj.batchExpireIn)
          filterObject.noOfDaysToExpire = this.$root.reportFilterObj.batchExpireIn.value == 'Today' ? 0 : Number(this.$root.reportFilterObj.batchExpireIn.value.substring(0, this.$root.reportFilterObj.batchExpireIn.value.indexOf(' ')));
        if(this.$root.reportFilterObj.inventoryType)
          filterObject.groupTypeId = this.$root.reportFilterObj.inventoryType.value == 'Goods' ? 101 : this.$root.reportFilterObj.inventoryType.value == 'Service' ? 102 : null;
        if(this.$root.reportFilterObj.godown)
          filterObject.godownId = this.$root.reportFilterObj.godown.id;
        if(this.$root.reportFilterObj.stockType)
          filterObject.qtyFilterMode = this.$root.reportFilterObj.stockType.value == 'All' ? 3 : filterObject.stockType = this.$root.reportFilterObj.stockType.value == 'Positive' ? 1 : filterObject.stockType = this.$root.reportFilterObj.stockType.value == 'Negative' ? 2 : 0;
        if(this.$root.reportFilterObj.stockSummarySortBy)
          filterObject.sortMode = this.$root.reportFilterObj.stockSummarySortBy.value == 'Product Name' ? 0 : this.$root.reportFilterObj.stockSummarySortBy.value == 'Category Name' ? 1 : null;
        if(this.$root.reportFilterObj.showZeroBalanceLedgers)
          filterObject.showZeroBalanceLedgers = this.$root.reportFilterObj.showZeroBalanceLedgers.value;
        }

      let itemId = null;

      if(this.reportId == 801 || this.reportId == 802 || this.reportId == 803 || this.reportId == 804){
        itemId = this.$root.CurrentBusiness.StateID;
      }
      else{
        itemId = this.$root.dataObj.itemId;
      }

      // // storing applied filters in local storage to re apply in case of view update
      // if(this.$root.reportFilterObj && Object.keys(this.$root.reportFilterObj).length){
      //   localStorage.setItem('report_filter_'+this.reportId, JSON.stringify(this.$root.reportFilterObj));  
      // }
      
      let self = this;

      this.$root.dataObj.subReportData = null;
      this.$root.dataObj.subReportData2 = null;

      // date calculation to include or not include income,expense openings in next fiscal year
      let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
      let openingYear = openingDate.getFullYear();
      let openingMonth = openingDate.getMonth() + 1;

      let openingFY = openingMonth <= 3 ? (openingYear - 1) : openingYear;

      let selectedStartDate = new Date(filterObject.startDate);
      let selectedStartDateYear = selectedStartDate.getFullYear();
      let selectedStartDateMonth = selectedStartDate.getMonth() + 1;

      let selectedStartDateFY = selectedStartDateMonth <= 3 ? (selectedStartDateYear - 1) : selectedStartDateYear;

      filterObject.includeOpening = true;
      if(selectedStartDateFY > openingFY){
        filterObject.includeOpening = false;
      }

      if((this.reportId == 201 || this.reportId == 601 || this.reportId == 602) && selectedStartDate > openingDate && selectedStartDateFY == openingFY){
        filterObject.includeOpening = false;
      }

      if(this.reportId == 102 || this.reportId == 601 || this.reportId == 602 || this.reportId == 603 || this.reportId == 901){
        filterObject.GSTRegistrationStatus = this.$root.CurrentBusiness.GSTRegistrationStatus;
        // filterObject.GSTRegistrationStatus = 1;
      }

      if(this.reportId == 108){
        filterObject.transactionListId = [10001];
        filterObject.formTransactionListId = [10002, 10003];
      }

      if(this.reportId == 417){
        filterObject.transactionListId = [20001];
        filterObject.formTransactionListId = [20002, 20003];
      }

      if((this.reportId == 601 || this.reportId == 901) && openingFY == selectedStartDateFY){
        filterObject.openingFYSelected = true;
      }

      if(this.$route.params.reportid == 301 && filterObject.partyId && filterObject.partyId.indexOf('SelectedItems') != -1){
        let parties = JSON.parse(filterObject.partyId);
        let selectedParties = JSON.parse(parties.SelectedItems);
        filterObject.partyIds = [];
        for(let i=0; i<selectedParties.length; i++){
          filterObject.partyIds.push(selectedParties[i].id);
        }
        filterObject.partyId = null;
      }

      console.log(JSON.stringify(filterObject));

      // if(this.reportId == 505){
      //   filterObject.partyId = itemId;
      //   itemId = null;
      // }

      this.getReportData('Report', itemId, filterObject,{

          onSuccess: function(response){
              console.log(response);

              let reportData = JSON.parse(response);

              // assigning static party Cash A/c in case of Daybook-202 and Purchase Tax Summary-403 when listId 20005
              // assigning static party Journal in case of Daybook-202 when listId 30003
              // if(self.reportId == 101 || self.reportId == 202 || self.reportId == 403){
                for(let i in reportData.data.detailRows){
                  if(self.reportId == 101 || self.reportId == 202 || self.reportId == 403 || self.reportId == 419){
                    if(!reportData.data.detailRows[i].cols.party){
                      if(reportData.data.detailRows[i].transactionListId == 20005){
                        reportData.data.detailRows[i].cols.party = "Cash A/c";
                      }
                      if(reportData.data.detailRows[i].transactionListId == 30003){
                        reportData.data.detailRows[i].cols.party = "Journal";
                      }
                      if(reportData.data.detailRows[i].transactionListId == 40004){
                        reportData.data.detailRows[i].cols.party = "Stock";
                      }
                    }
                  }
                  else if(self.reportId == 201){
                    if(reportData.data.detailRows[i].cols['creditDebitType'] == 'To Receive'){
                      reportData.data.detailRows[i].cols['creditDebitType'] = self.$root.fn_getDebitLabel();
                    }
                    else if(reportData.data.detailRows[i].cols['creditDebitType'] == 'To Pay'){
                      reportData.data.detailRows[i].cols['creditDebitType'] = self.$root.fn_getCreditLabel();
                    }

                    if(self.$root.TransactionSettings.ledgerCreditDebitLabelType == 2){
                      for(let key in dataConfig.headerRow){
                        if(key=='debit'){
                          dataConfig.headerRow[key] = self.$root.fn_getDebitLabel();
                        }
                        else if(key=='credit'){
                          dataConfig.headerRow[key] = self.$root.fn_getCreditLabel();
                        }
                      }

                      for(let i=0; i<dataConfig.headerRowTableHeaders.length; i++){
                        if(dataConfig.headerRowTableHeaders[i].headerName == 'To Receive'){
                          dataConfig.headerRowTableHeaders[i].headerName = self.$root.fn_getDebitLabel();
                        }
                        else if(dataConfig.headerRowTableHeaders[i].headerName == 'To Pay'){
                          dataConfig.headerRowTableHeaders[i].headerName = self.$root.fn_getCreditLabel();
                        }
                      }

                      if(reportData.data.footerRow['creditDebitType'] == 'To Receive'){
                        reportData.data.footerRow['creditDebitType'] = self.$root.fn_getDebitLabel();
                      }
                      else if(reportData.data.footerRow['creditDebitType'] == 'To Pay'){
                        reportData.data.footerRow['creditDebitType'] = self.$root.fn_getCreditLabel();
                      }
                    }
                  }

                  else if((self.reportId == 102 || self.reportId == 103) && self.$root.TransactionSettings.showSecondaryUnit && reportData.data.detailRows[i].cols['secondaryUnitName']){
                    reportData.data.detailRows[i].cols['productName'] = reportData.data.detailRows[i].cols['productName'] + ' (' + reportData.data.detailRows[i].cols['secondaryUnitPackQuantity'] + ' ' +reportData.data.detailRows[i].cols['secondaryUnitName'] + ')';
                  }

                  if(self.$root.TransactionSettings.showSecondaryUnit && self.$root.appVersion >= 253){
                    self.fn_processSecondaryUnitData(reportData.data.detailRows[i], reportData.data.footerRow, i);
                  }
                  else{
                    self.fn_removeSecondaryUnitData(reportData.data.detailRows[i]);
                  }
                  
                }                
              // }


              if(!self.$root.TransactionSettings.mrpWiseStock && (self.reportId == 101 || self.reportId == 102)){
                self.fn_removeMrpColumn(reportData.data);
              }
              else{
                self.$root.dataObj.reportData = reportData.data;
                // self.$root.dataObj.reportData.headerRow = dataConfig.headerRow;
                
                // removing header rows
                self.fn_removeHeaderRows();
                self.$root.dataObj.reportData.headerRow = dataConfig.headerRowTableHeaders;

                if(self.reportId == 803){
                  self.fn_generateDataForGSTR3B(reportData);
                }

                if(self.reportId==303 || self.reportId==403 || self.reportId==312 || self.reportId==419){
                  self.fn_calculateFooterValues();
                }
// self.$root.dataObj.tableView
                if(self.$root.dataObj.reportData.detailRows && self.$root.dataObj.tableView){
                  self.fn_generateTable();
                }
                else{
                  self.hideLoading();
                }
              }

              if(self.reportId == 205){
                self.fn_processLedgerDetailReport();
              }

              if(self.reportId == 310 || self.reportId == 311 || self.reportId == 312 || self.reportId == 418 || self.reportId == 419 || self.reportId == 420){
                // self.fn_processSaleRegisterDetailReport();
                self.fn_processDetailReport();
              }

          }, 
          onError: function(error){
              console.log(error);
              self.hideLoading();
          }

      });
  },

  fn_processLedgerDetailReport: function(){
      let rows = this.$root.dataObj.reportData.detailRows;

      let hasHsn = false;
      let hasDiscount = false;
      let hasCgst = false;
      let hasSgst = false;
      let hasUtgst = false;
      let hasIgst = false;
      let hasCess = false;
      let hasCessPercentage = false;
      let hasCessOnQtyPercentage = false;
      let hasGstPercentage = false;
      
      for(let i=0; i<rows.length; i++){
        if(rows[i].cols.itemDetailRows){

          
          let itemDetailRows = rows[i].cols.itemDetailRows;
          
          // let hasHsn = false;
          // let hasDiscount = false;
          // let hasCgst = false;
          // let hasSgst = false;
          // let hasUtgst = false;
          // let hasIgst = false;
          // let hasCess = false;

          for(let j=0; j<itemDetailRows.length; j++){
            itemDetailRows[j].srNo = j + 1;

            if(itemDetailRows[j].hsnCode)
              hasHsn = true;
            if(itemDetailRows[j].discount)
              hasDiscount = true;
            if(itemDetailRows[j].cgst)
              hasCgst = true;
            if(itemDetailRows[j].sgst)
              hasSgst = true;
            if(itemDetailRows[j].utgst)
              hasUtgst = true;
            if(itemDetailRows[j].igst)
              hasIgst = true;
            if(itemDetailRows[j].cess)
              hasCess = true;
            if(itemDetailRows[j].cessPercentage)
              hasCessPercentage = true;
            if(itemDetailRows[j].cessOnQtyPercentage)
              hasCessOnQtyPercentage = true;
            if(itemDetailRows[j].gstPercentage)
              hasGstPercentage = true;
          }

          let subHeaders = {
            'srNo':'#',
            'productName':"Description",
            "qty":"Qty",
            "unit":"Unit",
            "rate":"Rate/Unit",
            "taxableValue":"Taxable Value",
            "total":"Total"
          }

          if(hasHsn)
            subHeaders.hsnCode = "HSN/SAC";
          if(hasDiscount)
            subHeaders.discount = "Discount";
          if(hasCgst)
            subHeaders.cgst = "CGST";
          if(hasSgst)
            subHeaders.sgst = "SGST";
          if(hasUtgst)
            subHeaders.utgst = "UTST";
          if(hasIgst)
            subHeaders.igst = "IGST";
          if(hasCess)
            subHeaders.cess = "CESS";
          if(hasCessPercentage)
            subHeaders.cessPercentage = "CESS Percentage";
          if(hasCessOnQtyPercentage)
            subHeaders.cessOnQtyPercentage = "CESS on Qty Percentage";
          if(hasGstPercentage)
            subHeaders.gstPercentage = "GST Percentage";

          rows[i].subHeaders = subHeaders;

        }
      }
  },

  // fn_processSaleRegisterDetailReport: function(){
  fn_processDetailReport: function(){
      let rows = this.$root.dataObj.reportData.detailRows;

      let hasHsn = false;
      let hasDiscount = false;
      let hasCgst = false;
      let hasSgst = false;
      let hasUtgst = false;
      let hasIgst = false;
      let hasCess = false;
      let hasCessPercentage = false;
      let hasCessOnQtyPercentage = false
      let hasGstPercentage = false;
      
      for(let i=0; i<rows.length; i++){
        if(rows[i].cols.itemDetailRows){

          
          let itemDetailRows = rows[i].cols.itemDetailRows;

          for(let j=0; j<itemDetailRows.length; j++){
            itemDetailRows[j].srNo = j + 1;

            if(itemDetailRows[j].hsnCode)
              hasHsn = true;
            if(itemDetailRows[j].discount)
              hasDiscount = true;
            if(itemDetailRows[j].cgst)
              hasCgst = true;
            if(itemDetailRows[j].sgst)
              hasSgst = true;
            if(itemDetailRows[j].utgst)
              hasUtgst = true;
            if(itemDetailRows[j].igst)
              hasIgst = true;
            if(itemDetailRows[j].cess)
              hasCess = true;
            if(itemDetailRows[j].cessPercentage)
              hasCessPercentage = true;
            if(itemDetailRows[j].cessOnQtyPercentage)
              hasCessOnQtyPercentage = true;
            if(itemDetailRows[j].gstPercentage)
              hasGstPercentage = true;
          }

          let subHeaders = {
            'srNo':'#',
            'productName':"Description",
            "qty":"Qty",
            "unit":"Unit",
            "rate":"Rate/Unit",
            "taxableValue":"Taxable Value",
            "total":"Total"
          }

          if(hasHsn)
            subHeaders.hsnCode = "HSN/SAC";
          if(hasDiscount)
            subHeaders.discount = "Discount";
          if(hasCgst)
            subHeaders.cgst = "CGST";
          if(hasSgst)
            subHeaders.sgst = "SGST";
          if(hasUtgst)
            subHeaders.utgst = "UTST";
          if(hasIgst)
            subHeaders.igst = "IGST";
          if(hasCess)
            subHeaders.cess = "CESS";
          if(hasCessPercentage)
            subHeaders.cessPercentage = "CESS Percentage";
          if(hasCessOnQtyPercentage)
            subHeaders.cessOnQtyPercentage = "CESS on Qty Percentage";
          if(hasGstPercentage)
            subHeaders.gstPercentage = "GST Percentage";

          rows[i].subHeaders = subHeaders;

        }
      }
  },

  fn_generateDataForGSTR3B: function(reportData){
    let gstrData = {};
    gstrData.categories = [];

    for(let i in reportData.data.detailRows){

      if(reportData.data.detailRows[i].section == "3.1" && reportData.data.detailRows[i].mainRow){

        let sectionObj = {}
        sectionObj.subReportId = 'GSTR3B3_1';
        sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
        sectionObj.section = reportData.data.detailRows[i].section;
        sectionObj.subreportData = {};
        sectionObj.subreportData.data = {};
        sectionObj.subreportData.data.detailRows = [];

        if(reportData.data.detailRows[i].mainRow){
          sectionObj.items = [
            {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
            {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
            {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
            {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
          ];  
        }
        else{
          sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
        }
        

        gstrData.categories.push(sectionObj);
      }

      if(reportData.data.detailRows[i].section == "3.2" && reportData.data.detailRows[i].mainRow){

        let sectionObj = {}
        sectionObj.subReportId = "GSTR3B3_2";
        sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
        sectionObj.section = reportData.data.detailRows[i].section;
        sectionObj.subreportData = {};
        sectionObj.subreportData.data = {};
        sectionObj.subreportData.data.detailRows = [];

        if(reportData.data.detailRows[i].mainRow){
          sectionObj.items = [
            {"title":"Taxable Value", "value":reportData.data.detailRows[i].cols.taxableValue},
            {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst}
          ];
        }
        else{
          sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
        }

        gstrData.categories.push(sectionObj);
      }

      if(reportData.data.detailRows[i].section == "4" && reportData.data.detailRows[i].mainRow){
        let sectionObj = {}
        sectionObj.subReportId = "GSTR3B4";
        sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
        sectionObj.section = reportData.data.detailRows[i].section;
        sectionObj.subreportData = {};
        sectionObj.subreportData.data = {};
        sectionObj.subreportData.data.detailRows = [];

        if(reportData.data.detailRows[i].mainRow){
          sectionObj.items = [
            {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
            {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
            {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
            {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
          ];
        }
        else{
          sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
        }

        gstrData.categories.push(sectionObj);
      }

      if(reportData.data.detailRows[i].section == "5" && reportData.data.detailRows[i].mainRow){

        let sectionObj = {}
        sectionObj.subReportId = "GSTR3B5";
        sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
        sectionObj.section = reportData.data.detailRows[i].section;
        sectionObj.subreportData = {};
        sectionObj.subreportData.data = {};
        sectionObj.subreportData.data.detailRows = [];

        if(reportData.data.detailRows[i].mainRow){
          sectionObj.items = [
            {"title":"Inter-State Supplies", "value":reportData.data.detailRows[i].cols.interStateAmount},
            {"title":"Intra-State Supplies", "value":reportData.data.detailRows[i].cols.intraStateAmount}
          ];
        }
        else{
          sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
        }

        gstrData.categories.push(sectionObj);
      }

      if(reportData.data.detailRows[i].section == "5.1" && reportData.data.detailRows[i].mainRow){
        let sectionObj = {}
        sectionObj.subReportId = "GSTR3B5_1";
        sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
        sectionObj.section = reportData.data.detailRows[i].section;
        sectionObj.subreportData = {};
        sectionObj.subreportData.data = {};
        sectionObj.subreportData.data.detailRows = [];

        if(reportData.data.detailRows[i].mainRow){
          sectionObj.items = [
            {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
            {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
            {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
            {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
          ];
        }
        else{
          sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
        }

        gstrData.categories.push(sectionObj);
      }
      
    }

    this.$root.dataObj.reportData.gstr3BData = JSON.parse(JSON.stringify(gstrData));
    console.log(JSON.stringify(gstrData));
  },

  fn_removeMrpColumn: function(reportData){

    let removeMrpColumn = false;

    // for(let col in dataConfig.headerRow){
    //   if(dataConfig.headerRow[col] == 'MRP'){
    //     columnName = col;
    //     reportData.footerRow ? delete reportData.footerRow[col] : '';
    //     delete dataConfig.headerRow[col];
    //     break;
    //   }
    // }
    for(let i=0; i<dataConfig.headerRowTableHeaders.length; i++){
      if(dataConfig.headerRowTableHeaders[i].headerName == 'MRP'){
        // columnName = dataConfig.headerRowTableHeaders[i].headerName;
        removeMrpColumn = true;
        // reportData.footerRow ? delete reportData.footerRow[columnName] : '';
        reportData.footerRow ? delete reportData.footerRow["mrp"] : '';

        dataConfig.headerRow ? delete dataConfig.headerRow["mrp"] : '';
        dataConfig.headerRowTableHeaders.splice(i, 1);
        // delete dataConfig.headerRowTableHeaders[i];
        break;
      }
    }

    if(removeMrpColumn){
      for(let row=0; row<reportData.detailRows.length; row++){
        // delete reportData.detailRows[row].cols[columnName];
        delete reportData.detailRows[row].cols["mrp"];
      }

      let colIndex = this.$root.dataObj.columns.findIndex(col=>{
        // return col == columnName;
        return col == "mrp";
      });

      colIndex!=-1 ? this.$root.dataObj.columns.splice(colIndex, 1) : '';
    }

    this.$root.dataObj.reportData = reportData;
    // this.$root.dataObj.reportData.headerRow = dataConfig.headerRow;
    this.$root.dataObj.reportData.headerRow = dataConfig.headerRowTableHeaders;

    if(this.$root.dataObj.reportData.detailRows && this.$root.dataObj.tableView){
      this.fn_generateTable();
    }
    else{
      this.hideLoading();
    }
  },

  fn_calculateFooterValues: function(){
    let footerRow = {};
    footerRow.transactionDate = "Total";
    footerRow.party = null;
    footerRow.mergeTransactionNumber = null;
    footerRow.transactionListId = null;
    footerRow.gstNumber = null;
    footerRow.grossAmount = 0;
    footerRow.discount = 0;
    footerRow.otherCharges = 0;
    footerRow.taxableValue = 0;
    footerRow.cgst = 0;
    footerRow.stgst = 0;
    footerRow.igst = 0;
    footerRow.cess = 0;
    footerRow.additionalValue = 0;
    footerRow.roundedOff = 0;
    footerRow.roundedAmount = 0;
    footerRow.totalTax = this.$root.dataObj.reportData.footerRow.tax;
    let detailRows = this.$root.dataObj.reportData.detailRows;
    for(let i=0; i<detailRows.length; i++){
      for(let col in detailRows[i].cols){
        if(col=='grossAmount'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.grossAmount += detailRows[i].cols[col];
        }
        else if(col=='discount'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.discount += detailRows[i].cols[col];
        }
        else if(col=='otherCharges'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.otherCharges += detailRows[i].cols[col];
        }
        else if(col=='taxableValue'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.taxableValue += detailRows[i].cols[col];
        }
        else if(col=='cgst'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.cgst += detailRows[i].cols[col];
        }
        else if(col=='stgst'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.stgst += detailRows[i].cols[col];
        }
        else if(col=='igst'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.igst += detailRows[i].cols[col];
        }
        else if(col=='cess'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.cess += detailRows[i].cols[col];
        }
        else if(col=='additionalValue'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.additionalValue += detailRows[i].cols[col];
        }
        else if(col=='roundedOff'){
          // if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
          //   // detailRows[i].cols[col] = -detailRows[i].cols[col];
          //   footerRow.roundedOff += detailRows[i].cols[col];
          // }
          footerRow.roundedOff += detailRows[i].cols[col];
        }
        else if(col=='roundedAmount'){
          if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            detailRows[i].cols[col] = -detailRows[i].cols[col];
          }
          footerRow.roundedAmount += detailRows[i].cols[col];
        }
      }

      footerRow.grossAmount = this.roundUpto2Decimals(footerRow.grossAmount);
      footerRow.discount = this.roundUpto2Decimals(footerRow.discount);
      footerRow.otherCharges = this.roundUpto2Decimals(footerRow.otherCharges);
      footerRow.taxableValue = this.roundUpto2Decimals(footerRow.taxableValue);
      footerRow.cgst = this.roundUpto2Decimals(footerRow.cgst);
      footerRow.stgst = this.roundUpto2Decimals(footerRow.stgst);
      footerRow.igst = this.roundUpto2Decimals(footerRow.igst);
      footerRow.cess = this.roundUpto2Decimals(footerRow.cess);
      footerRow.additionalValue = this.roundUpto2Decimals(footerRow.additionalValue);
      footerRow.roundedOff = this.roundUpto2Decimals(footerRow.roundedOff);
      footerRow.roundedAmount = this.roundUpto2Decimals(footerRow.roundedAmount);
      footerRow.totalTax = this.roundUpto2Decimals(footerRow.totalTax);

      this.$root.dataObj.reportData.footerRow = footerRow;
      console.log(JSON.stringify(this.$root.dataObj.reportData));
    }
  },

  // fn_getReportItemDetails: function(itemId){
    fn_getReportItemDetails: function(transactionListId, transactionId){
      let filterObject = {};
      // filterObject.reportId = this.$root.dataObj.detailReportId;
      filterObject.reportId = 2011;

      this.detailReportObj = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(2011)));

      let self = this;
      this.getReportData('Report', transactionId, filterObject,{

          onSuccess: function(response){
              console.log(response);

              let reportData = JSON.parse(response);
              self.$set(self.detailReportObj, 'detailRows', reportData.data.detailRows);
              self.$set(self.detailReportObj, 'footerRow', reportData.data.footerRow);
              self.detailReportObj.transactionId = transactionId;
              self.detailReportObj.transactionListId = transactionListId;
              self.$forceUpdate();
              self.bottomSheet = true;
          }, 
          onError: function(error){
              console.log(error);
          }

      });
  },

  fn_action: function(type, share){
    share ? this.fn_closeDialog() : '';

    let self = this;

  //   if(this.reportId == 803 && !this.$refs['ref_gstrSubReport'].dialog_gst_report && !this.$refs['ref_gstrSubReport2'].dialog_gst_report){
      if(this.reportId == 803){
          // filtering only main rows before export to pdf
          let wholeReport = JSON.parse(JSON.stringify(this.$root.dataObj.reportData.detailRows));
          this.$root.dataObj.reportData.detailRows = this.$root.dataObj.reportData.detailRows.filter(item=>{
          return item.mainRow;
      });

      // assigning whole data back after export
      setTimeout(function(){
        self.$root.dataObj.reportData.detailRows = JSON.parse(JSON.stringify(wholeReport));
      },2000);
    }

    // let fileDownloadTime = new Date();
    // let fileName = this.$root.dataObj.reportTitle.replace(' ', '_').toLowerCase() + '_' + fileDownloadTime.getTime();
    let fileName = this.$root.dataObj.reportTitle.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();

    // Remove old style if exists
    let old = document.getElementById('dynamic-page-size');
    if (old) old.remove();

    if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
      if(type=='pdf'){
        this.$root.fn_checkStoragePermission(function(){
          setTimeout(function(){
            self.fn_exportToPdf(fileName+'.pdf', share);
          },300);
        })
      }
      else if(type=='print'){
        AndroidRoutingTest.print(fileName, "A4", "false");
      }
    }
    else{
      window.print();
    }

  },

  fn_openDialogAndroid: function(){
      if(this.$root.dataObj.itemLabel == 'Party'){
          this.fn_accountLedgers('android', 'AccountLedger', null);
      }
      else if(this.$root.dataObj.itemLabel == 'Item'){
          this.fn_items('android', 'Item', null);
      }
  },

  fn_accountLedgers: function (platform, name, ref) {

      var tagId = this.guidWeb();

      var dialogObj = {};
      dialogObj.tagId = tagId;
      dialogObj.formId = this.formId;
      dialogObj.name = name;
      dialogObj.ref = ref;
      dialogObj.platform = platform;

      var viewDialogObject = {};
      viewDialogObject.ToolbarTitle = "Select Ledger";
      viewDialogObject.isBottomMenu = false;
      viewDialogObject.hideChip = true;
      viewDialogObject.enableFilterChip = true;

      // if(this.partyGroupTypeId){
      //   viewDialogObject.groupTypeId = this.partyGroupTypeId;
      // }

      if(this.$root.dataObj.selectedAccountGroupTypeId){
        viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
      }
      else{
        viewDialogObject.groupTypeId = 101; 
      }

      var paramObject = {};
      paramObject.defaultValue = {"id":null, "name":null};

      // if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
      //     paramObject.defaultValue = {"id":this.$root.dataObj.itemId, "name":this.$root.dataObj.itemName};
      // }
      
      // dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);

      if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
        paramObject.defaultValue = {"id":this.$root.dataObj.itemId, "name":this.$root.dataObj.itemName};
        this.fn_getPartyData(this.$root.dataObj.itemId, dialogObj, viewDialogObject, tagId, paramObject, ref)
      }
      else{
        dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
      }
      
  },

  fn_getPartyData: function(itemId, dialogObj, viewDialogObject, tagId, paramObject, ref){
      let self = this;
      this.getData('Ledger', itemId, 
      {
        onSuccess: function(response){
            console.log(response);
            let partyData = JSON.parse(response);
            if(partyData){
              // self.partyGroupTypeId = partyData.groupTypeId;
              self.fn_selectedGroupTypeId(partyData.groupTypeId);
              viewDialogObject.groupTypeId = partyData.groupTypeId;
              dialogjs.fn_openDialog(self, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
            }
        }, 
        onError: function(error){
            console.log(error);
            self.hideLoading();
        }
      }
    );
  },

  fn_selectedGroupTypeId: function(groupTypeId){
    this.$root.dataObj.selectedAccountGroupTypeId = Number(groupTypeId);
  },

  fn_items: function (platform, name, ref) {

      var tagId = this.guidWeb();

      var dialogObj = {};
      dialogObj.tagId = tagId;
      dialogObj.formId = this.formId;
      dialogObj.name = name;
      dialogObj.ref = ref;
      dialogObj.platform = platform;

      var viewDialogObject = {};
      viewDialogObject.ToolbarTitle = "Select Item";
      viewDialogObject.isBottomMenu = false;
      viewDialogObject.hideChip = true;
      viewDialogObject.showDeactivated = true;

      if(this.$route.params.reportid == 101 || this.$route.params.reportid == 104 || this.$route.params.reportid == 109){
        viewDialogObject.groupTypeId = 101;
        viewDialogObject.inventory = 1;
      }
      // this.$route.params.reportid == 101 ? viewDialogObject.inventory = 1 : '';

      var paramObject = {};
      paramObject.defaultValue = {"id":null, "name":null};

      if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
          paramObject.defaultValue = {"id":this.$root.dataObj.itemId, "name":this.$root.dataObj.itemName};
      }
      
      dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
  },

  fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
    if(ref!='null'){
      // this.$refs['ref_filter'].fn_updateItem(selectedValueId, selectedValueName, isRemoved, ref);
      this.fn_updateFilterItem(selectedValueId, selectedValueName, isRemoved, ref);
    }
    else{
      this.fn_updateItem(selectedValueId, selectedValueName, isRemoved);
    }
  },

  fn_updateItem: function(selectedValueId, selectedValueName, isRemoved, nextRoute){
      if(!isRemoved){
        console.log('update item');
          this.$root.dataObj.itemId = selectedValueId;
          this.$root.dataObj.itemName = selectedValueName;
          // this.fn_getPartyData(selectedValueId);
          nextRoute && nextRoute.query.isFilter ? this.fn_updateFilter(nextRoute) : this.fn_getReportData();
          this.$forceUpdate();
      }
  },

  fn_openDialogWeb: function (platform, name, ref) {

      let scroll_y = window.scrollY;
      this.fn_fixBackgroundScroll();

      var tagId = this.guidWeb();

      var dialogObj = {};
      dialogObj.tagId = tagId;
      dialogObj.formId = this.formId;
      dialogObj.name = name;
      dialogObj.ref = ref;
      dialogObj.data = null;
      dialogObj.platform = platform;

      dialogObj.scrollPosition = {};
      dialogObj.scrollPosition.x = 0;
      dialogObj.scrollPosition.y = scroll_y;

      dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

      this.$refs[ref].openDialogWeb();
  },

  fn_closeDialog: function () {
      dialogjs.fn_checkAndCloseOpenDialogs(this);
  },

  fn_goBack: function(){
      this.$route.query.subreport == 2 ? this.$root.dataObj.subReportData2 = null : '';
      this.$router.go(-1);
  },

  fn_closeAndExportExcelFile: function(fileId){
      let self = this;
      this.closeFile(fileId, {

        onSuccess: function(response){
            console.log(response);
            if(self.shareExcel){
              self.fn_shareReport('xlsx');
            }
            else{
              self.showToast('File downloaded');
              self.snackbar = true;  
            }
        }, 
        onError: function(error){
            console.log(error);
            self.showToast('File download failed');
        }

      });
  },

  // fn_exportToExcel: function(data, fileName){
  //     let self = this;
  //     this.exportToExcel(data, fileName,{

  //       onSuccess: function(response){
  //           console.log(response);
  //           if(self.shareExcel){
  //             self.fn_shareReport('xlsx');
  //           }
  //           else{
  //             self.showToast('File downloaded');
  //             self.snackbar = true;  
  //           }
  //       }, 
  //       onError: function(error){
  //           console.log(error);
  //           self.showToast('File download failed');
  //       }

  //     });
  // },

  fn_exportToPdf: function(fileName, share){
      let self = this;
      this.exportToPdf(fileName, 'false',{

        onSuccess: function(response){
            console.log(response);
            if(share){
              self.fn_shareReport('pdf');
            }
            else{
              self.showToast('File downloaded');
              self.snackbar = true;
            }
        },
        onError: function(error){
            console.log(error);
            self.showToast('File download failed');
        }
      });
  },

  fn_shareReport: function(type){
    let shareObj = {};
    shareObj.type = type;
    shareObj.primaryMobileNumber = null
    // shareObj.subject = this.$root.dataObj.reportTitle;
    shareObj.subject = this.$root.dataObj.reportTitle + " report from " + this.$root.CurrentBusiness.BusinessName;
    shareObj.email = null
    // shareObj.textMessage = null;
    shareObj.textMessage = this.$tShare('share.reportAttached', {
      title: this.$root.dataObj.reportTitle,
      businessName: this.$root.CurrentBusiness.BusinessName
    });
    this.$root.fn_share(shareObj);
  },

  fn_openTransaction: function(listId, transactionId){

    let transactionListId = Number(listId);

    let title = null;
    for(let i=0;i<transactionForms.length;i++){
      if(transactionListId == transactionForms[i].id){
        title = transactionForms[i].title;
        break;
      }
    }

    if(transactionListId == transactionTypes.order.id || transactionListId == transactionTypes.deliveryChallan.id || transactionListId == transactionTypes.salesInvoice.id || transactionListId == transactionTypes.salesReturn.id || transactionListId == transactionTypes.estimate.id){
      this.$router.push('/transactions/sales/'+title.toLowerCase().replace(/ /g,'')+'/items/'+transactionId);
    }
    else if(transactionListId == transactionTypes.purchaseOrder.id || transactionListId == transactionTypes.purchaseChallan.id || transactionListId == transactionTypes.purchaseInvoice.id || transactionListId == transactionTypes.purchaseReturn.id || transactionListId == transactionTypes.expense.id){
      this.$router.push('/transactions/purchase/'+title.toLowerCase().replace(/ /g,'')+'/items/'+transactionId);
    }
    // else if(transactionListId == transactionTypes.receipt.id || transactionListId == transactionTypes.payment.id || transactionListId == transactionTypes.journal.id || transactionListId == transactionTypes.contra.id || transactionListId == transactionTypes.debitNote.id || transactionListId == transactionTypes.creditNote.id){
    else if(transactionListId == transactionTypes.receipt.id || transactionListId == transactionTypes.payment.id || transactionListId == transactionTypes.journal.id || transactionListId == transactionTypes.contra.id){
      this.$router.push('/transactions/'+title.toLowerCase().replace(/ /g,'')+'/items/'+transactionId);
    }
    else if(transactionListId == transactionTypes.stockJournal.id){
      this.$router.push({path:'/transactions/inventory/stockjournal/items/'+transactionId});
    }
    else if(transactionListId == transactionTypes.stockAdjustment.id){
      this.$router.push({path:'/transactions/inventory/stockadjustment/items/'+transactionId});
    }
    else if(transactionListId == transactionTypes.openingLedger.id){
      this.$router.push('/transactions/inventory/openingstock/items/'+transactionId);
    }
    else if(transactionListId == transactionTypes.openingStock.id){
      this.$router.push('/transactions/inventory/openingledger/items/'+transactionId);
    }
    else if(transactionListId == transactionTypes.stockTransfer.id){
      this.$router.push({path:'/transactions/inventory/stocktransfer/items/'+transactionId});
    }
    else if(transactionListId == transactionTypes.bomProduction.id){
      this.$router.push({path:'/transactions/inventory/billofmaterials/items/'+transactionId});
    }
    
  },

  fn_openAccountDetails: function(accountId){
    this.$router.push({path:"/masters/accounts/ledgers/items/"+accountId});
  },

  fn_openFilterDialog: function (name, ref, id, value, dialogName) {

      var tagId = this.guidWeb();

      var dialogObj = {};
      dialogObj.tagId = tagId;
      dialogObj.formId = this.formId;
      dialogObj.name = name;
      dialogObj.ref = ref;
      dialogObj.platform = 'android';

      var viewDialogObject = {};
      viewDialogObject.ToolbarTitle = "Select "+name;
      viewDialogObject.isBottomMenu = false;
      name == 'Brand' ? viewDialogObject.listId = listIdObject.brandListGUID : '';
      name == 'Prescriber' ? viewDialogObject.listId = listIdObject.prescriberListGUID : '';
      let reportId = this.$route.params.reportid;

      if(name=='Transaction Form'){
        reportId == 303 || reportId == 312 ? viewDialogObject.transactionTypeId = [10003] : '';
        reportId == 403 || reportId == 419 ? viewDialogObject.transactionTypeId = [20003, 20005] : '';
      }

      if(reportId == 104 || reportId == 105 || reportId == 108 || reportId == 109 || reportId == 606){
        viewDialogObject.groupTypeId = 101;
        viewDialogObject.inventory = 1;
      }

      if(reportId == 302){
        viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id]; 
      }
      else if(reportId == 402){
        viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id]; 
      }

      if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409 || reportId == 418 || reportId == 419 || reportId == 420){
        if((reportId == 403 || reportId == 419) && name == 'Tax Type'){
          viewDialogObject.accountGroupIds = [accountGroupIds.purchaseAccount.id];
        }
        else{
          viewDialogObject.enableFilterChip = true;
          if(this.$root.dataObj.selectedAccountGroupTypeId){
            viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
          }
          else{
            viewDialogObject.groupTypeId = 102;
          }
        }
        // else{
        //   viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id];
        // }
      }
      else if(reportId == 101 || reportId == 202 || reportId == 203 || reportId == 301 || reportId == 303 || reportId == 304 || reportId == 305 || reportId == 308 || reportId == 411){
        if((reportId == 303 || reportId == 312) && name == 'Tax Type'){
          viewDialogObject.accountGroupIds = [accountGroupIds.saleAccount.id];
        }
        else{
          viewDialogObject.enableFilterChip = true;
          if(this.$root.dataObj.selectedAccountGroupTypeId){
            viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
          }
          else{
            viewDialogObject.groupTypeId = 101;
          }
        }
        // else{
        //   viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id];
        //   reportId == 101 ? viewDialogObject.accountGroupIds.push(accountGroupIds.brandAndDivision.id) : '';
        // }
      }

      // // enabling chip filters in case of party/account dialog filter
      // if(ref == 'ref_fieldParty'){
      //   viewDialogObject.enableFilterChip = true;
      //   if(this.partyGroupTypeId){
      //     viewDialogObject.groupTypeId = this.partyGroupTypeId;
      //   }
      //   if(this.$root.dataObj.selectedAccountGroupTypeId){
      //     viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
      //   }
      //   else if(reportId == 301 || reportId == 303 || reportId == 304 || reportId == 305 || reportId == 308){
      //     viewDialogObject.groupTypeId = 101;
      //   }
      //   else if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409){
      //     viewDialogObject.groupTypeId = 102;
      //   }
      // }

      if(ref == 'ref_fieldSalesman'){
        viewDialogObject.accountGroupIds = [accountGroupIds.salesmen.id];
        viewDialogObject.groupTypeId = 103;
      }
      else if(ref == 'ref_fieldBroker'){
        viewDialogObject.accountGroupIds = [accountGroupIds.brokers.id];
        viewDialogObject.groupTypeId = 103;
      }

      var paramObject = {};
      paramObject.defaultValue = {"id":null, "name":null};

      if(id && value){
          paramObject.defaultValue = {"id":id, "name":value};
      }

      if(ref == 'ref_fieldParties' && this.$route.params.reportid == 301){
        viewDialogObject.showCheck = true;
      }
      
      if(ref=='ref_fieldTransactionForm'){
        this.fn_getExcludeGroups(dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);  
      }
      else if(ref=='ref_fieldParty' && id && value){
        this.fn_getPartyData(id, dialogObj, viewDialogObject, tagId, paramObject, ref)
      }
      // else if(ref=='ref_fieldParty'){
      //   // enabling chip filters in case of party/account dialog filter
      //   viewDialogObject.enableFilterChip = true;
      //   if(this.$root.dataObj.selectedAccountGroupTypeId){
      //     viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
      //   }
      //   else if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409){
      //     viewDialogObject.groupTypeId = 102;
      //   }
      //   else{
      //     viewDialogObject.groupTypeId = 101;
      //   }

      //   // getting party groupTypeId if already selected else open dialog
      //   if(id && value){
      //     this.fn_getPartyData(id, dialogObj, viewDialogObject, tagId, paramObject, ref);
      //   }
      //   else{
      //     dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);  
      //   }

      // }
      else{
        dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);
      }
      
  },

  fn_getExcludeGroups: function(dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref){
    let filterObject = {};
    filterObject.accountGroupsHidden = [2];

    let self = this;
    this.getFilterData('ExcludeGroups', null, filterObject, 
      {
        onSuccess: function(response){
          console.log(response);
          viewDialogObject.accountGroupsHidden = JSON.parse(response);
          dialogjs.fn_openDialog(self, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);
        }, 
        onError: function(error){
          console.log(error);
        }
      }
    );
  },

  fn_clearAllFilters: function(filterObj){
    console.log('clear filter container');
    let dataConfig = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.$route.params.reportid)));
    // JSON.parse(JSON.stringify(require('./data.js').data.fn_getData(this.reportId)));
    let dateObj = this.fn_getTimeSpan(dataConfig.period);
    this.$root.dataObj.startDate = dateObj.startDate;
    this.$root.dataObj.endDate = dateObj.endDate;
    this.fn_getReportData(filterObj);
    this.fn_closeFilters();
  },

  fn_getReportDataFileName: function(){
      if(this.$root.CurrentBusiness.GSTRegistrationStatus==1)
          return "data_registered.js";
      else if(this.$root.CurrentBusiness.GSTRegistrationStatus==2)
          return "data_composite.js";
      else if(this.$root.CurrentBusiness.GSTRegistrationStatus==3)
          return "data_unregistered.js";
  },

  fn_openDialogTaxRateList: function(closeDialog){
    if(closeDialog){
      this.fn_closeDialog();
      let self = this;
      setTimeout(function(){
        self.fn_openDialogWeb('web', 'TaxRateList', 'ref_dialogTaxRateList');
      },300)
    }
    else{
      if(this.compTaxRate.type==2){
        this.fn_openDialogCompTaxRate();
      }
      else{
        this.fn_openDialogWeb('web', 'TaxRateList', 'ref_dialogTaxRateList');
      }
    }
  },

  fn_openDialogCompTaxRate: function(){
    this.fn_openDialogWeb('web', 'CompTaxRate', 'ref_dialogCompTaxRate');
  },

  fn_updateTaxRate: function(taxRate, type){
    this.fn_closeDialog();
    if(taxRate == 'custom'){
      let self = this;
      this.compTaxRate.value = null;
      this.compTaxRate.type = 2;
      setTimeout(function(){
        self.fn_openDialogCompTaxRate();
      },300);
    }
    else{
      this.fn_closeDialog();
      this.compTaxRate.value = taxRate;
      this.compTaxRate.type = type ? type : 1;
      let valueObj = {};
      valueObj.taxRate = this.compTaxRate.value;
      valueObj.type = this.compTaxRate.type;
      this.fn_postReportPreferences(804, valueObj);
    }
    // this.compTaxRate = taxRate
  },

  fn_initializeData: function(itemId, itemName, nextRoute){
    // this.reportId = !this.reportId ? this.$route.params.reportid : '';
    this.$root.reportFilterObj = {};

  //   let dataFileName = null;

    // if(this.$root.CurrentBusiness.GSTRegistrationStatus==1)
    //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/'+dataFileName).data.fn_getData(this.reportId)));
    // else if(this.$root.CurrentBusiness.GSTRegistrationStatus==2)
    //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/data_composite.js').data.fn_getData(this.reportId)));
    // else if(this.$root.CurrentBusiness.GSTRegistrationStatus==3)
    //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/data_unregistered.js').data.fn_getData(this.reportId)));

    dataConfig = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.reportId)));

    // this.$root.reportFilters = JSON.parse(JSON.stringify(require('./data_config/data_registered.js').data.filters));
    this.$root.reportFilters = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.filters));

    if(this.$root.CurrentBusiness.GSTRegistrationStatus==2){
      this.compTaxRateList = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.taxRates));        
    }

    this.$root.dataObj.reportTitle = dataConfig.reportTitle;
    this.$root.dataObj.itemId = itemId ? itemId : null;
    this.$root.dataObj.itemName = itemName ? itemName : null;
    this.$root.dataObj.columns = dataConfig.columns;

    this.$root.dataObj.tileViewColumns = dataConfig.tileViewColumns;
    this.$root.dataObj.tileContent = dataConfig.tileContent;
    this.$root.dataObj.footerContent = dataConfig.footerContent;
    this.$root.dataObj.tileViewFooterHeaders = dataConfig.tileViewFooterHeaders;
    
    this.$root.dataObj.footerColumns = dataConfig.footerColumns ? dataConfig.footerColumns : null;
    this.$root.dataObj.itemLabel = dataConfig.itemLabel;
    this.$root.dataObj.periodLabel = dataConfig.periodLabel;
    // removing sales man filter if not enabled from settings
    if(!this.$root.TransactionSettings.enableSalesman){
      let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldSalesman'});
      this.$root.reportFilters.splice(fIndex, 1);
    }
    // removing broker filter if not enabled from settings
    if(!this.$root.TransactionSettings.enableBroker){
      let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldBroker'});
      this.$root.reportFilters.splice(fIndex, 1);
    }

    if(!this.$root.TransactionSettings.enableGodown){
      let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldGodown'});
      this.$root.reportFilters.splice(fIndex, 1);
    }

    this.$root.dataObj.filters = dataConfig.filters
    this.$root.dataObj.openView = dataConfig.openView
    this.$root.dataObj.hideFilterBtn = dataConfig.hideFilterBtn ? dataConfig.hideFilterBtn : false;

    this.$root.dataObj.reportData = {"headerRow":null};
    this.$root.dataObj.detailReportId = null;

    //Setting up default period report wise

    let defaultDateObj = this.fn_getTimeSpan(dataConfig.period);

    if(localStorage.getItem('report_period_'+this.reportId)){
      let periodObj = JSON.parse(localStorage.getItem('report_period_'+this.reportId));
      this.$root.dataObj.startDate = periodObj.startDate ? periodObj.startDate : defaultDateObj.startDate;
      this.$root.dataObj.endDate = periodObj.endDate ? periodObj.endDate : defaultDateObj.endDate;
      this.$root.dataObj.selectedPeriod = periodObj.selectedPeriod;
    }
    // else if(nextRoute && nextRoute.query && (nextRoute.query.startDate && nextRoute.query.endDate)){
    else if(nextRoute && nextRoute.query && nextRoute.query.endDate){
      this.$root.dataObj.startDate = nextRoute.query.startDate ? nextRoute.query.startDate : defaultDateObj.startDate;
      this.$root.dataObj.endDate = nextRoute.query.endDate ? nextRoute.query.endDate : defaultDateObj.endDate;
      // nextRoute.query.selectedPeriod ? this.$root.dataObj.selectedPeriod = nextRoute.query.selectedPeriod : '';
      this.$root.dataObj.selectedPeriod = nextRoute.query.selectedPeriod ? nextRoute.query.selectedPeriod : null;
    }
    else{
      this.$root.dataObj.startDate = defaultDateObj.startDate;
      this.$root.dataObj.endDate = defaultDateObj.endDate;
    }

    // if(dataConfig.detailReportId){
    //   this.$root.dataObj.detailReportId = dataConfig.detailReportId;
    //   this.detailReportObj = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(dataConfig.detailReportId)));
    // }

    this.$root.dataObj.reportType = dataConfig.reportType;

    if(!dataConfig.openDialog){
      // this.fn_getReportData();
      if(nextRoute && nextRoute.query && nextRoute.query.isFilter){
        this.fn_updateFilter(nextRoute);
      }
      else{
        // this.fn_getReportData();
        if(this.reportId == 804){
          if(!this.$root.dataObj.reportPreferences){
            this.fn_openDialogTaxRateList();
          }
          else{
            this.fn_updateFilterItem(null, this.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
            // this.$refs['ref_filter'].fn_updateItem(null, this.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
          }
        }
        else{
          console.log('init data');
          this.fn_getReportData();
        }
      }
    }
    else{
      if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
        this.fn_updateItem(this.$root.dataObj.itemId, this.$root.dataObj.itemName, false, nextRoute);
      }
      else{
        this.fn_openDialogAndroid();
      }
    }
    
    console.log(this.$root.dataObj);
  },

  fn_updateFilter: function(nextRoute){
    if(nextRoute.query.filterPartyId && nextRoute.query.filterPartyName){
      this.fn_updateFilterItem(nextRoute.query.filterPartyId, nextRoute.query.filterPartyName, false, "ref_fieldParty");
      // let self = this;
      // setTimeout(function(){
      //   self.$refs['ref_filter'].fn_updateItem(nextRoute.query.filterPartyId, nextRoute.query.filterPartyName, false, "ref_fieldParty");  
      // },2000);
    }
    else if(nextRoute.query.filtertypeFormName == "Expense"){
      this.fn_updateFilterItem(transactionTypeForms.expense.id, transactionTypeForms.expense.name, false, "ref_fieldTransactionForm");
    }
  },

  fn_updateFilterItem: function(selectedValueId, selectedValueName, isRemoved, ref){
      for(let i=0; i<this.$root.reportFilters.length; i++){
          if(this.$root.reportFilters[i].ref == ref){
              if(!isRemoved){
                  this.$root.reportFilters[i].id = selectedValueId;
                  this.$root.reportFilters[i].value = selectedValueName;  

                  if(this.$route.params.reportid == 301 && ref=='ref_fieldParties'){
                    let selecteds = JSON.parse(this.$root.reportFilters[i].id);
                    let selectedParties = JSON.parse(selecteds.SelectedItems);
                    this.$root.reportFilters[i].value = '';
                    for(let j=0; j<selectedParties.length; j++){
                      let name = selectedParties.length != 1 && j != selectedParties.length - 1 ? selectedParties[j].name + ', ' : selectedParties[j].name;
                      this.$root.reportFilters[i].value += name;
                    }
                    console.log('f1')
                    this.fn_applyFilter(selectedValueId, this.$root.reportFilters[i].value, ref);
                  }
                  else{
                    console.log('f2')
                    this.fn_applyFilter(selectedValueId, selectedValueName, ref);
                  }
                  // ref=='ref_fieldParty' ? this.fn_getPartyData(selectedValueId) : '';
                  // this.fn_applyFilter(selectedValueId, selectedValueName, ref);
                  break;
              }
              else{
                  this.$root.reportFilters[i].id = null;
                  this.$root.reportFilters[i].value = null;
                  this.fn_closeDialog();
                  console.log('f3')
                  this.fn_applyFilter(null, null, ref);
                  break;
              }
          }
      }
  },

  fn_applyFilter: function(selectedValueId, selectedValueName, ref){
      // this.fn_closeFilters();

      if(ref=='ref_fieldParty')
          selectedValueId ? this.$root.reportFilterObj.party = {"id":selectedValueId, "name":"Party", "value":selectedValueName}: delete this.$root.reportFilterObj.party;
      if(ref=='ref_fieldParties')
          selectedValueId ? this.$root.reportFilterObj.party = {"id":selectedValueId, "name":"Party", "value":selectedValueName}: delete this.$root.reportFilterObj.party;
      if(ref=='ref_fieldItem')
          selectedValueId ? this.$root.reportFilterObj.product = {"id":selectedValueId, "name":"Product", "value":selectedValueName}: delete this.$root.reportFilterObj.product;
      if(ref=='ref_fieldCategory')
          selectedValueId ? this.$root.reportFilterObj.category = {"id":selectedValueId, "name":"Category", "value":selectedValueName}: delete this.$root.reportFilterObj.category;
      if(ref=='ref_fieldBrand')
          selectedValueId ? this.$root.reportFilterObj.brand = {"id":selectedValueId, "name":"Brand", "value":selectedValueName}: delete this.$root.reportFilterObj.brand;
      if(ref=='ref_fieldTaxType')
          selectedValueId ? this.$root.reportFilterObj.taxType = {"id":selectedValueId, "name":"Tax Type", "value":selectedValueName}: delete this.$root.reportFilterObj.taxType;
      if(ref=='ref_fieldTransactionForm')
          selectedValueId ? this.$root.reportFilterObj.transactionTypeForm = {"id":selectedValueId, "name":"Transaction Form", "value":selectedValueName}: delete this.$root.reportFilterObj.transactionTypeForm;
      if(ref=='ref_fieldAccountGroup')
          selectedValueId ? this.$root.reportFilterObj.accountGroup = {"id":selectedValueId, "name":"Account Group", "value":selectedValueName}: delete this.$root.reportFilterObj.accountGroup;
      if(ref=='ref_fieldPrescriber')
          selectedValueId ? this.$root.reportFilterObj.prescriber = {"id":selectedValueId, "name":"Prescriber", "value":selectedValueName}: delete this.$root.reportFilterObj.prescriber;
      if(ref=='ref_fieldSalesman')
          selectedValueId ? this.$root.reportFilterObj.salesman = {"id":selectedValueId, "name":"Salesman", "value":selectedValueName}: delete this.$root.reportFilterObj.salesman;
      if(ref=='ref_fieldBroker')
          selectedValueId ? this.$root.reportFilterObj.broker = {"id":selectedValueId, "name":"Broker", "value":selectedValueName}: delete this.$root.reportFilterObj.broker;
      if(ref=='status')
          selectedValueName ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":selectedValueName}: delete this.$root.reportFilterObj.status;
      if(ref=='groupTypeId')
          selectedValueName ? this.$root.reportFilterObj.groupTypeId = {"id":null, "name":"Type", "value":selectedValueName}: delete this.$root.reportFilterObj.groupTypeId;
      if(ref=='ref_compTaxRate')
          selectedValueName ? this.$root.reportFilterObj.taxRate = {"id":null, "name":"GST Rate (%)", "value":selectedValueName}: delete this.$root.reportFilterObj.taxRate;
      if(ref=='showoutofstock')
          selectedValueName ? this.$root.reportFilterObj.showOutOfStock = {"id":null, "name":"Out of Stock", "value":selectedValueName}: delete this.$root.reportFilterObj.showOutOfStock;
      if(ref=='dueDays')
          selectedValueName ? this.$root.reportFilterObj.dueDays = {"id":null, "name":"Due Days", "value":Number(selectedValueName)}: delete this.$root.reportFilterObj.dueDays;
      if(ref=='showmsme')
        selectedValueName ? this.$root.reportFilterObj.showMSME = {"id":null, "name":"MSME", "value":selectedValueName}: delete this.$root.reportFilterObj.showMSME;
      if(ref=='showAllBatch')
        selectedValueName ? this.$root.reportFilterObj.showAllBatch = {"id":null, "name":"All Batches", "value":selectedValueName}: delete this.$root.reportFilterObj.showAllBatch;
      if(ref=='batchExpireIn')
        selectedValueName ? this.$root.reportFilterObj.batchExpireIn = {"id":null, "name":"Expire In", "value":selectedValueName}: delete this.$root.reportFilterObj.batchExpireIn;
      if(ref=='itemGroupType')
          selectedValueName ? this.$root.reportFilterObj.inventoryType = {"id":null, "name":"Type", "value":selectedValueName}: delete this.$root.reportFilterObj.inventoryType;
      if(ref=='ref_fieldGodown')
          selectedValueId ? this.$root.reportFilterObj.godown = {"id":selectedValueId, "name":"Godown", "value":selectedValueName}: delete this.$root.reportFilterObj.godown;
      if(ref=='stockType')
          selectedValueName ? this.$root.reportFilterObj.stockType = {"id":null, "name":"Stock Type", "value":selectedValueName}: delete this.$root.reportFilterObj.stockType;
      if(ref=='stockSummarySortBy')
          selectedValueName ? this.$root.reportFilterObj.stockSummarySortBy = {"id":null, "name":"Sort By", "value":selectedValueName}: delete this.$root.reportFilterObj.stockSummarySortBy;
      if(ref=='showZeroBalanceLedgers')
        selectedValueName ? this.$root.reportFilterObj.showZeroBalanceLedgers = {"id":null, "name":"Zero Balance Ledgers", "value":selectedValueName}: delete this.$root.reportFilterObj.showZeroBalanceLedgers;
      this.fn_getReportData(this.$root.reportFilterObj);
      console.log('apply filter');
  },

  fn_changeView: function(){
    this.$root.dataObj.tableView = !this.$root.dataObj.tableView;

    localStorage.setItem('table_view', this.$root.dataObj.tableView);
    // localStorage.setItem("defaultReportView", this.$root.dataObj.$root.dataObj.tableView);
    if(this.$root.dataObj.tableView && this.$root.dataObj.reportData && this.$root.dataObj.reportData.detailRows && this.$root.dataObj.reportData.detailRows.length){
        this.showLoading('Updating View...');
        this.fn_generateTable();
    }
    
  },

  // fn_openPermissionDialog: function(permissionType){
  //     this.$root.permissionType = permissionType;
  //     this.fn_openDialogWeb('web', 'Permission', 'ref_dialogPermission');
  // },

  fn_getGSTPortalData: function(){
      // this.exportExcel = true;

      this.showLoading('Please wait...');

      let filterObject = {};
      filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
      filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

      filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
      filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

      let dataSheets = [];

      let self = this;
      this.getFilterData('GSTPortalData', this.$root.CurrentBusiness.StateID, filterObject,{
          onSuccess: function(response){
              console.log(response);
              let data = JSON.parse(response);
              for(let key in dataConfig.gstPortalReportObj){
                  let dataObj = {};
                  dataObj.otherData = {};
                  dataObj.reportDataObject = {};
                  dataObj.reportDataObject.reportData = {};
                  dataObj.reportDataObject.reportData.detailRows = data[key] ?  data[key] : [];
                  dataObj.reportDataObject.reportData.headerRow = dataConfig.gstPortalReportObj[key].headerRow;
                  dataObj.reportDataObject.headerRow1 = dataConfig.gstPortalReportObj[key].title;
                  dataObj.reportDataObject.headerRow2 = null;
                  dataObj.reportDataObject.headerRow3 = null;
                  dataObj.otherData.sheetName = key;
                  dataSheets.push(dataObj);
              }

              console.log(JSON.stringify(dataSheets));

              // callback(excelData);
              self.fn_prepareExcelForGSTPortal(dataSheets);
          },
          onError: function(error){
              console.log(error);
              self.showToast("Something went wrong");
              self.hideLoading();
          }
      });
  },

  fn_prepareExcelForGSTPortal: function(dataSheets){
      let sheets = [];

      for(let j=0; j<dataSheets.length; j++){

          let headerRow1 = [dataSheets[j].reportDataObject.headerRow1];
          let headerRow2 = [dataSheets[j].reportDataObject.headerRow2];
          let headerRow3 = [dataSheets[j].reportDataObject.headerRow3];
      
          let tableHeader = [];
          let headerCols = dataSheets[j].reportDataObject.reportData.headerRow;

          let keyIndex = -1;
          let objLength = Object.keys(headerCols).length;
          for(let key in headerCols){
              keyIndex++;
              tableHeader.push(headerCols[key]);
              // pushing null to all remaining
              if(keyIndex < objLength - 1){
                  headerRow1.push(null);
                  headerRow2.push(null);
                  headerRow3.push(null);
              }
          }

          var excelData = {};
          excelData.sheetName = dataSheets[j].otherData.sheetName;
          excelData.data = [];
          excelData.data.push(headerRow1);
          excelData.data.push(headerRow2);
          excelData.data.push(headerRow3);
          excelData.headerRowCount = 4;

          excelData.data.push(tableHeader);

          for(var i=0; i<dataSheets[j].reportDataObject.reportData.detailRows.length; i++){

              let tableRow = [];
              let item = dataSheets[j].reportDataObject.reportData.detailRows[i];
              for(let key in headerCols){
                  console.log(headerCols[key]+': '+item[key]);
                  if(headerCols[key]=='Date' || key=='transactionDate' || key=='shippingBillDate' || key=='referenceTransactionDate' || key=='expiryDate' || key=='expDate' || key=='mfgDate'){
                      item[key] = item[key] ? this.$moment(item[key]).format('DD-MMM-YYYY') : '';
                  }
                  tableRow.push(item[key]);
              }

              excelData.data.push(tableRow);

          }

          sheets.push(excelData);
      }

      this.fn_exportGSTPortalExcel(sheets);
  },

  fn_exportGSTPortalExcel: function(sheetsDataArr){
      console.log('called 2');

      let self = this;

      const XlsxPopulate = require('xlsx-populate');

      XlsxPopulate.fromBlankAsync().then(workbook => {
          // Modify the workbook.
          console.log('called 3');
          for(let i=0; i<sheetsDataArr.length; i++){
              
              let sheetName = sheetsDataArr[i].sheetName.replace(/\//g, '');
              workbook.addSheet(sheetName, i);

              workbook.sheet(i).cell("A1").value(sheetsDataArr[i].data);

              var tbl_LastColumn_Index = sheetsDataArr[i].data[0].length;

              //Getting fourth row and first col address
              // const tbl_FourthRow_FirstCell = workbook.sheet(i).cell(4,1).address();
              //Getting fourth row last col address
              // const tbl_FourthRow_LastCell = workbook.sheet(i).cell(4,tbl_LastColumn_Index).address();

              // var headerRange = tbl_FourthRow_FirstCell+":"+tbl_FourthRow_LastCell;
              
              // //Setting cell styles
              // workbook.sheet(i).range(headerRange).style({"fill": "F8CBAD"});
              // workbook.sheet(i).range("A1:A1").style({"fill": "0070C0", "fontColor":"ffffff", "bold": true, "wrapText":true});

              let alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
              for(let k=0; k<tbl_LastColumn_Index; k++){
                  let colValLength = workbook.sheet(i).cell(alphabets[k]+"4").value().length + 5;
                  workbook.sheet(i).column(alphabets[k]).width(colValLength);
              }

              for(let row=0; row<sheetsDataArr[i].data.length; row++){

                  for(let col=0; col<sheetsDataArr[i].data[row].length; col++){
                      
                      let colValue = sheetsDataArr[i].data[row][col];
                      
                      if(sheetsDataArr[i].sheetName != 'docs' && typeof(colValue) == 'number'){
                          let cellAddress = workbook.sheet(i).cell((row+1),(col+1)).address();
                          workbook.sheet(i).cell(cellAddress).style("numberFormat", "0.00");
                      }
                      
                      // if(self.$moment(colValue, "DD-MMM-YYYY", true).isValid()){  
                      //     let cellAddress = workbook.sheet(i).cell((row+1),(col+1)).address();
                      //     let cellValue = workbook.sheet(i).cell((row+1),(col+1)).value();
                      //     let dateObj = new Date(cellValue);
                      //     workbook.sheet(i).cell(cellAddress).value(dateObj).style("numberFormat", "dd-mmm-yyyy");
                      // }
                  }
              }
          }

          workbook.deleteSheet("Sheet1");
          workbook.activeSheet(0);

          workbook.outputAsync("base64").then(function (base64) {
              var raw = window.atob(base64);
              var rawLength = raw.length;
              var array = new Uint8Array(new ArrayBuffer(rawLength));

              for(var i = 0; i < rawLength; i++) {
                  array[i] = raw.charCodeAt(i);
              }

              // self.postMessage(array);
              self.fn_saveGSTPortalFile(array);
          });

          
      });
  },

  fn_saveGSTPortalFile: function(data){
      var fileName = "GSTR-1_"+this.$root.CurrentBusiness.GSTNumber+"_"+this.$root.fn_getCurrentDateTimeString();
      
      var chunkcounter = 0;
      if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
          console.log('inside');

          //opening file
          let fileId = this.guidWeb();
          AndroidRoutingTest.openFile(fileId, fileName+'.xlsx');

          //writing file
          var chunkSize = data.BYTES_PER_ELEMENT * 1000 * 2; //self.$parent.datachunksize //1 byte
          for (var i = 0; i < data.length; i += chunkSize) {
              var datachunk = data.slice(i, i + chunkSize)
              AndroidRoutingTest.writeFile(fileId, datachunk);
              console.log(++chunkcounter);
          }

          //closing file
          console.log("close");
          this.hideLoading();
          this.fn_closeAndExportExcelFile(fileId);
      }
  },

  fn_removeHeaderRows: function(){
    if(this.reportId == 101){
      let hIndex = dataConfig.headerRowTableHeaders.findIndex(item=>{return item.headerName == 'Pack Qty'});
      if(!this.$root.TransactionSettings.showPacking){
        dataConfig.headerRowTableHeaders.splice(hIndex, 1);
        delete dataConfig.headerRow.packing;
        dataConfig.columns.splice(hIndex);
      }
      else{
        if(hIndex != -1){
          dataConfig.headerRowTableHeaders[hIndex].headerName = this.$root.TransactionSettings.packingLabel ? this.$root.TransactionSettings.packingLabel : "Pack Qty";
        }
      }
    }
  },

  // fn_processSecondaryUnitData: function(row, footerRow, index){
  //   if(this.reportId == 102){
  //     let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
  //     if(secondaryUnitPackQty){
  //       row.cols['secondaryUnitPackQuantity'] = this.roundUpto2Decimals(secondaryUnitPackQty) + row.cols['secondaryUnitName'];
  //       row.cols['totalSecondaryUnitPackQuantity'] = ((this.roundUpto2Decimals(row.cols['realQty'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //     }

  //     if(footerRow && footerRow.secondaryUnitPackQuantity && footerRow.packQuantity && index == 0){
  //       footerRow.totalSecondaryUnitPackQuantity = this.roundUpto2Decimals((footerRow.dqty * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity);
  //     }
  //   }
  //   else if(this.reportId == 101 || this.reportId == 103){
  //     let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
  //     if(secondaryUnitPackQty){
  //       if(row.cols['inwardReal']){
  //         row.cols['secondaryUnitPackQuantityInward'] = ((this.roundUpto2Decimals(row.cols['inwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(row.cols['outwardReal']){
  //         row.cols['secondaryUnitPackQuantityOutward'] = ((this.roundUpto2Decimals(row.cols['outwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(row.cols['balanceReal']){
  //         row.cols['closingSecondaryUnitPackQuantity'] = ((this.roundUpto2Decimals(row.cols['balanceReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(row.cols['closingReal']){
  //         row.cols['closingSecondaryUnitPackQuantity'] = ((this.roundUpto2Decimals(row.cols['closingReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(footerRow && footerRow.actualInwardValueReal){
  //         footerRow.secondaryUnitPackQuantityInward = ((this.roundUpto2Decimals(footerRow.actualInwardValueReal * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(footerRow && footerRow.actualOutwardValueReal){
  //         footerRow.secondaryUnitPackQuantityOutward = ((this.roundUpto2Decimals(footerRow.actualOutwardValueReal * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //       if(footerRow && footerRow.balanceReal){
  //         footerRow.closingSecondaryUnitPackQuantity = ((this.roundUpto2Decimals(footerRow.balanceReal * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
  //       }
  //     }
      
  //   }
  // },

  fn_processSecondaryUnitData: function(row, footerRow, index){
    if(this.reportId == 102){
      let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
      if(secondaryUnitPackQty){
        row.cols['secondaryUnitPackQuantity'] = this.roundUpto2Decimals(secondaryUnitPackQty) + ' ' + row.cols['secondaryUnitName'];
        // fix for real qty double from android side
        // let rQty = row.cols['realQty'] / 2;
        // row.cols['totalSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((rQty * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
        row.cols['totalSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['realQty'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
      }

      if(footerRow && footerRow.secondaryUnitPackQuantity && footerRow.packQuantity && index == 0){
        footerRow.totalSecondaryUnitPackQuantity = this.roundUpto2Decimals((footerRow.realQty * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity);
      }
    }
    else if(this.reportId == 101 || this.reportId == 103){
      let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
      if(secondaryUnitPackQty){
        if(row.cols['inwardReal']){
          row.cols['secondaryUnitPackQuantityInward'] = this.roundUpto2Decimals(((row.cols['inwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
        }
        if(row.cols['outwardReal']){
          row.cols['secondaryUnitPackQuantityOutward'] = this.roundUpto2Decimals(((row.cols['outwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
        }
        if(row.cols['balanceReal']){
          row.cols['closingSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['balanceReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
        }
        if(row.cols['closingReal']){
          row.cols['closingSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['closingReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
        }
        if(footerRow && footerRow.actualInwardValueReal){
          footerRow.secondaryUnitPackQuantityInward = this.roundUpto2Decimals(((footerRow.actualInwardValueReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
        }
        if(footerRow && footerRow.actualOutwardValueReal){
          footerRow.secondaryUnitPackQuantityOutward = this.roundUpto2Decimals(((footerRow.actualOutwardValueReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
        }
        if(footerRow && footerRow.balanceReal){
          footerRow.closingSecondaryUnitPackQuantity = this.roundUpto2Decimals(((footerRow.balanceReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
        }
      }
      
    }
  },

  fn_removeSecondaryUnitData: function(row){
    if(this.reportId == 102){
      
      // let headerLength = dataConfig.headerRowTableHeaders.length;
      let qtyPackIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Qty (Per Pack)"});

      if(qtyPackIndex != -1){
        dataConfig.headerRowTableHeaders.splice(qtyPackIndex, 1);
        dataConfig.columns.splice(qtyPackIndex, 1);
      }

      let totalPackIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Total (Pack)"});

      if(totalPackIndex != -1){
        dataConfig.headerRowTableHeaders.splice(totalPackIndex, 1);
        dataConfig.columns.splice(totalPackIndex, 1);
      }
      // removing headers rows
      // dataConfig.headerRowTableHeaders.splice(headerLength - 1, 1);
      // dataConfig.headerRowTableHeaders.splice(headerLength - 2, 1);

      // dataConfig.columns.splice(headerLength - 1, 1);
      // dataConfig.columns.splice(headerLength - 2, 1);

      delete dataConfig.headerRow.secondaryUnitPackQuantity;
      delete dataConfig.headerRow.totalSecondaryUnitPackQuantity;
    }
    else if(this.reportId == 101 || this.reportId == 103){

      let inwardIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Inward (Per Pack)"});
      
      if(inwardIndex != -1){
        dataConfig.headerRowTableHeaders.splice(inwardIndex, 1);
        dataConfig.columns.splice(inwardIndex, 1);
      }

      let outwardIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Outward (Per Pack)"});
      if(outwardIndex != -1){
        dataConfig.headerRowTableHeaders.splice(outwardIndex, 1);
        dataConfig.columns.splice(outwardIndex, 1);
      }

      let balanceIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Balance (Pack)"});
      if(balanceIndex != -1){
        dataConfig.headerRowTableHeaders.splice(balanceIndex, 1);
        dataConfig.columns.splice(balanceIndex, 1);
      }

      let closingIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Closing (Pack)"});
      if(closingIndex != -1){
        dataConfig.headerRowTableHeaders.splice(closingIndex, 1);
        dataConfig.columns.splice(closingIndex, 1);
      }

      // let headerLength = dataConfig.headerRowTableHeaders.length;

      // removing headers rows
      // dataConfig.headerRowTableHeaders.splice(headerLength - 1, 1);
      // dataConfig.headerRowTableHeaders.splice(headerLength - 2, 1);
      // dataConfig.headerRowTableHeaders.splice(headerLength - 3, 1);

      // dataConfig.columns.splice(headerLength - 1, 1);
      // dataConfig.columns.splice(headerLength - 2, 1);
      // dataConfig.columns.splice(headerLength - 3, 1);

      delete dataConfig.headerRow.secondaryUnitPackQuantityInward;
      delete dataConfig.headerRow.secondaryUnitPackQuantityOutward;
      delete dataConfig.headerRow.closingSecondaryUnitPackQuantity;
    }
  },

  fn_openDialogFyfilter: function(){
    this.fn_openDialogWeb('web', 'Filter', 'ref_dialogFiscalYearFilter');
  },
},  
mounted: function(){
  this.dialogStorageId = 'dialog_'+this.guidWeb();
  window.js_globals.fn_selectedGroupTypeId = this.fn_selectedGroupTypeId;
  window.js_globals.fn_closeClick = this.fn_closeDialog;
  window.js_globals.fn_onBackPress = this.fn_goBack;
  // window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;

  let self = this;
  setTimeout(function(){
      self.isGoBack = true;
  },500);

  let myworker = work(require.resolve('../plugins/worker_prepare_excel_data.js'));

  myworker.addEventListener('message', event => {

      var fileName = self.$root.dataObj.reportTitle.replace(/\//g, '') + '-Report_' + this.$root.fn_getCurrentDateTimeString()

      if(this.$route.query.subreport == 1){
          fileName = self.$root.dataObj.subReportData.reportTitle.replace(/\//g, '') + '-Report_' + this.$root.fn_getCurrentDateTimeString()
      }
  
      if(this.$route.query.subreport == 2){
          fileName = self.$root.dataObj.subReportData2.reportTitle.replace(/\//g, '') + '-Report_' + this.$root.fn_getCurrentDateTimeString()
      }
      
      var chunkcounter = 0;
      if(typeof AndroidRoutingTest !== "undefined" && AndroidRoutingTest !== null){
          console.log('inside');

          //opening file
          let fileId = self.guidWeb();
          AndroidRoutingTest.openFile(fileId, fileName+'.xlsx');

          //writing file
          var chunkSize = event.data.BYTES_PER_ELEMENT * 1000 * 2; //self.$parent.datachunksize //1 byte
          for (var i = 0; i < event.data.length; i += chunkSize) {
              var datachunk = event.data.slice(i, i + chunkSize)
              AndroidRoutingTest.writeFile(fileId, datachunk);
              console.log(++chunkcounter);
          }

          //closing file
          console.log("close");
          self.fn_closeAndExportExcelFile(fileId);
      }
      else{
          console.log('not web view');
      }

  });

  document.getElementById('exportExcelBtn').onclick = function(){
      self.$root.fn_checkStoragePermission(function(){
          self.shareExcel = false;
          processDataForExcel();
      })
  }

  document.getElementById('shareExcelBtn').onclick = function(){
      self.$root.fn_checkStoragePermission(function(){
          self.shareExcel = true;
          self.fn_closeDialog();
          self.showToast('Preparing excel to share');
          processDataForExcel();
      })
  }


  function processDataForExcel(){

      let startDate = null;
      let endDate = null;

      if(self.$root.dataObj.startDate){
          startDate = self.$moment(self.$root.dataObj.startDate).format('DD-MMM-YYYY');  
      }
      
      if(self.$root.dataObj.endDate){
          endDate = self.$moment(self.$root.dataObj.endDate).format('DD-MMM-YYYY');
      }

      let subReportData = null;
      let isSubReport = false;
      if(self.$route.query.subreport){
          isSubReport = true;
          startDate = self.$moment(self.$route.query.startDate).format('DD-MMM-YYYY'); 
          endDate = self.$moment(self.$route.query.endDate).format('DD-MMM-YYYY'); 
          if(self.$route.query.subreport == 1){
              subReportData = self.$root.dataObj.subReportData;  
          }
          else if(self.$route.query.subreport == 2){
              subReportData = self.$root.dataObj.subReportData2;
          }
      }
      

      let dataObj = {};

      if(isSubReport){
          dataObj = {"reportDataObject":{}}
          dataObj.reportDataObject.reportData = JSON.parse(JSON.stringify(subReportData.data));
          dataObj.reportDataObject.reportData.headerRow = subReportData.headerRow;
          dataObj.reportDataObject.reportData.internalHeaderRow = subReportData.internalHeaderRow;
      }
      else{
          dataObj.reportDataObject = JSON.parse(JSON.stringify(self.$root.dataObj)); 

          // removing subreport columns in case of excel export
          if(self.reportId == 803){
              dataObj.reportDataObject.reportData.detailRows = dataObj.reportDataObject.reportData.detailRows.filter(item=>{
              return item.mainRow;
              });
              console.log(JSON.stringify(dataObj.reportDataObject));
          }
      }

      // deletion as date oject creating problem while posting data to webworker
      delete dataObj.reportDataObject.filters;
      delete dataObj.reportDataObject.startDate;
      delete dataObj.reportDataObject.endDate;

      dataObj.otherData = {};
      dataObj.reportDataObject.reportData.headerRow = isSubReport ? subReportData.headerRow : dataConfig.headerRow;
      dataObj.otherData.headerRow1 = self.$root.CurrentBusiness.BusinessName;
      dataObj.otherData.headerRow2 = isSubReport ? subReportData.reportTitle : self.$root.dataObj.reportTitle;

      let sdate = startDate ? startDate + ' To ' : '';
      dataObj.otherData.headerRow3 = self.$root.dataObj.periodLabel + ': ' + sdate + endDate;

      dataObj.otherData.headerRow4 = self.$root.dataObj.itemLabel ? self.$root.dataObj.itemLabel+ ': ' + self.$root.dataObj.itemName : null;

      if(self.$root.reportFilterObj && Object.keys(self.$root.reportFilterObj).length){
          dataObj.otherData.headerRow5 = '';
          for(let key in self.$root.reportFilterObj){
              let index = 0;
              dataObj.otherData.headerRow5 += self.$root.reportFilterObj[key].name + ': ' + self.$root.reportFilterObj[key].value + (index != Object.keys(self.$root.reportFilterObj).length-1 ? ', ' : '');
              index++
          }
      }

      console.log(JSON.stringify(dataObj));

      myworker.postMessage(dataObj);
  }
},
beforeRouteEnter (to, from, next) {
  next(vm => {
      vm.reportId = vm.$route.params.reportid;
  
      console.log(vm.$route);
      // empty report data object before route enter
      vm.$root.dataObj.reportData = {"headerRow":null};

      if(from.name == 'reports'){
          reportList.forEach(item => {
              for(let i=0; i<item.items.length; i++) {
                  localStorage.removeItem('report_period_'+item.items[i].reportId);
              }
          });
      }

      if(from.name == 'reports'){
          vm.$root.dataObj.selectedAccountGroupTypeId = null;
          localStorage.removeItem("table_view");
          vm.reportId == 601 || vm.reportId == 602 || vm.reportId == 603 || vm.reportId == 804 || vm.reportId == 901 || vm.reportId == 411 || vm.reportId == 205 || vm.reportId == 310 || vm.reportId == 311 || vm.reportId == 312 || vm.reportId == 418 || vm.reportId == 419 || vm.reportId == 420 ?  vm.$root.dataObj.tableView = true : vm.$root.dataObj.tableView = false;
          vm.fn_getReportPreferences(vm.reportId);
      }
      else{
        console.log('route enter');
          vm.fn_getReportData(vm.$root.reportFilterObj);
      }
  })
},
beforeRouteUpdate(to, from, next){
  var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
  if(dialogData && dialogData.length){
      dialogjs.fn_checkAndCloseOpenDialogs(this);
      next(false);
  }
  else if(this.filter_sheet || this.tileViewDetailSheet || this.tileViewTotalSheet || this.bottomSheet){
      this.filter_sheet = false;
      this.tileViewDetailSheet = false;
      this.tileViewTotalSheet = false;
      this.bottomSheet = false;
      next(false);
  }
  else{
      this.hideLoading();
      let itemId =  to.query.itemId ? to.query.itemId : null;
      let itemName =  to.query.itemName ? to.query.itemName : null;
      this.reportId = to.params.reportid;
      
      if(localStorage.getItem("table_view")){
      this.reportId == 601 || this.reportId == 602 || this.reportId == 603 || this.reportId == 804 || this.reportId == 901 || this.reportId == 411 ? this.$root.dataObj.tableView = true : this.$root.dataObj.tableView = JSON.parse(localStorage.getItem("table_view"));
      }
      else{
      localStorage.setItem('table_view', this.$root.dataObj.tableView);
      }

      if(this.reportId == 505 || this.reportId == 604){
        localStorage.removeItem('report_period_'+this.reportId);
      }
      
      !to.query.subreport ? this.fn_getReportPreferences(this.reportId, itemId, itemName, to) : '';
      next();
  }
},
beforeRouteLeave (to, from, next) {
  var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
  if(dialogData && dialogData.length){
      dialogjs.fn_checkAndCloseOpenDialogs(this);
      next(false);
  }
  else if(this.bottomSheet && to.name == 'reports'){
      this.bottomSheet = false;
      next(false);
  }
  else if(this.filter_sheet || this.tileViewDetailSheet || this.tileViewTotalSheet){
      this.filter_sheet = false;
      this.tileViewDetailSheet = false;
      this.tileViewTotalSheet = false
      next(false);
  }
  else{
      localStorage.removeItem('report_period_'+this.$route.params.reportid);
      this.hideLoading();
      next(true);
  }
}

}
</script>

<style>
.drawer_left_btn{
  margin: 0 !important;
}
.drawer_right_btn,
.dialog_right_btn{
  min-width: 60px !important;
}
.navigation-drawer{
  z-index: 99 !important;
  padding: 0 !important;
}
.navigation-drawer .filter_categories{
  height: 100%;
  overflow: auto;
}
.navigation-drawer .filter_categories .list__tile__action{
  color: rgb(153, 153, 153);
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-direction: inherit;
  align-items: center;
  display: block;
  text-align: right;
  padding: 14px 0px;
}
.overlay{
  z-index: 98;
}
.filterdialog{
  height: 100%;
  max-height: 100% !important;
  margin: 0 !important;
  position: absolute;
  right: 0;
}
.filtercard.card{ 
  height: 100% !important;
  overflow: hidden !important;
}
.filtercard.card .card__title,
.custom_dates.card .card__title{
  padding: 0 !important;
}
.filtercard.card .card__text{
  height: 100%;
  padding: 0px;
}
.filtercard.card .card__text .radiogroup{
  padding: 10px 0px !important;
}
.filterdialog .list{
  padding: 0;
}
.filterdialog .customheader .list__tile{
  padding-right: 0;
}
.filterdialog .list .list__tile .list__tile__action{
  min-width: 40px;
}
.filter_dialog.list__tile .right_content{
  font-size:small;color:#1976d2;position:absolute;right:0;
}
#custom_overlay{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background: rgba(0,0,0,0.4);
  // z-index: 90;
}
.checkbox_tile .list__tile{
  padding-top: 10px;
}


.dialog_search .card{
  height: 100% !important;
  overflow: hidden !important;
  background-color: #F0F0F0 !important;
}
.dialog_search .card__title{
  height: 48px;
  background-color: #fff;
  padding: 0;
}
.dialog_search .card__title .input-group{
  padding-right: 12px !important;
  padding-top: 0;
}
.input-group .input-group__input .icon{
  color: rgba(0,0,0,.54) !important;
}
.dialog_search .card__title .input-group .input-group__details{
  min-height: 16px !important;
  display: none;
}
.dialog_search .card__title .input-group .input-group__details:before,
.dialog_search .card__title .input-group .input-group__details:after{
  display: none;
}
.dialog_search .card__text{
  padding: 0px;
  height: calc(100% - 58px);
  overflow: auto;
  margin-top: 8px;
  background-color: #fff;
}
.dialog_search .list{
  width: 100%;
  /*height: 100%;*/
  padding-top: 0;
}
.progress-linear{
  height: 2px !important;
  margin: 0 !important;
}
.card_text_msg{
  width: 100%;
    text-align: center;
    font-size: 16px;
}
.right-align{
  text-align: right !important;
}
/*#startdate, #enddate{
  visibility:hidden;position:absolute
}*/
.noresult{
  padding:16px;text-align:center
}
.select_options .radio-group{
  padding: 0;
}
.select_options .radio-group .input-group__input .radio{
  padding-bottom: 8px;
}
#btn:focus{
  outline: none;
}
</style>


// "headerRow":{"col1":"Vch No.","col2":"Date","col3":"Vch.Type","col4":"Particulars","col5":"Unit","col6":"Inward","col7":"Outward","col8":"Balance"},"detailRows":[{"cols":{"col1":"","col2":"","col3":"","col4":"Opening","col5":"","col6":"","col7":"","col8":0}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2}},{"id":"5891fb7f-eb29-457a-a8c9-7877893df7d2","cols":{"col1":"TI/2","col2":"2018-06-11","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":-4}},{"id":"ca061443-d762-47bd-ab04-edd7be0eea6e","cols":{"col1":"PB/3","col2":"2018-06-12","col3":"Purchase Invoice","col4":"S","col5":"Pcs","col6":10,"col7":"","col8":6}},{"id":"ca061443-d762-47bd-ab04-edd7be0eea6e","cols":{"col1":"PB/3","col2":"2018-06-12","col3":"Purchase Invoice","col4":"S","col5":"Case (Pcs)","col6":10,"col7":"","col8":106}},{"id":"b445cc65-12b8-4d76-a5bc-97402ac81248","cols":{"col1":"EI/1","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":104}},{"id":"2cdb3b97-132d-48ed-a4e0-915a11ae7b8a","cols":{"col1":"EI/2","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":102}},{"id":"2f63e976-42dc-43e3-b138-9c4fa85b0631","cols":{"col1":"TI/3","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":100}},{"id":"21d28632-6b94-4d80-b8fe-05816f09a3fe","cols":{"col1":"TI/4","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":98}},{"id":"71f9abed-5c4c-4959-945c-f0d6b6ee829c","cols":{"col1":"TI/5","col2":"2018-06-13","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":3,"col8":95}},{"id":"d87b6ef0-3988-42be-80d1-013f126db0a6","cols":{"col1":"TI/6","col2":"2018-06-13","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":1,"col8":94}},{"id":"d7342d30-90ba-4249-8022-4b625e2efcfe","cols":{"col1":"TI/7","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":5,"col8":89}},{"id":"93cfba19-3c70-486b-8468-3f446946d1dd","cols":{"col1":"TI/8","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":2,"col8":87}},{"id":"84955b64-9dc6-441a-a7bf-86bbc0ac97cb","cols":{"col1":"TI/9","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":3,"col8":84}},{"id":"6edc71a9-ee9b-4682-ac2c-67354af41a4f","cols":{"col1":"TI/10","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":1,"col8":83}},{"id":"b4a43349-1f30-4722-9e8d-b9b87206356f","cols":{"col1":"DC/1","col2":"2018-06-19","col3":"Delivery Challan","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":81}},{"id":"7b20079e-76a6-4744-847c-6ffc7b70d58b","cols":{"col1":"TI/11","col2":"2018-06-27","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":2,"col8":79}},{"id":"ef9a93f1-2733-4bef-939d-86a93d492da7","cols":{"col1":"TI/13","col2":"2018-07-02","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":1,"col8":78}},{"id":"96c7d332-624f-47b7-a107-af49bcb72917","cols":{"col1":"TI/14","col2":"2018-07-02","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":3,"col8":75}},{"id":"c4fd6ed6-7c5d-4030-840d-5bb24a39206d","cols":{"col1":"TI/15","col2":"2018-07-06","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":2,"col8":73}},{"id":"3ed73d3f-708f-4f3d-8646-03d68fa16019","cols":{"col1":"TI/16","col2":"2018-07-06","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":5,"col8":68}},{"id":"d7766b55-456c-46fd-82a0-d7d6c6692673","cols":{"col1":"TI/17","col2":"2018-07-12","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":10,"col8":58}},{"id":"d7766b55-456c-46fd-82a0-d7d6c6692673","cols":{"col1":"TI/17","col2":"2018-07-12","col3":"Sale Invoice","col4":"Abc","col5":"Case (Pcs)","col6":"","col7":5,"col8":8}},{"cols":{"col1":"","col2":"","col3":"","col4":"Opening","col5":"","col6":"","col7":"","col8":0}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2}},{"id":"5891fb7f-eb29-457a-a8c9-7877893df7d2","cols":{"col1":"TI/2","col2":"2018-06-11","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":-4}},{"id":"ca061443-d762-47bd-ab04-edd7be0eea6e","cols":{"col1":"PB/3","col2":"2018-06-12","col3":"Purchase Invoice","col4":"S","col5":"Pcs","col6":10,"col7":"","col8":6}},{"id":"ca061443-d762-47bd-ab04-edd7be0eea6e","cols":{"col1":"PB/3","col2":"2018-06-12","col3":"Purchase Invoice","col4":"S","col5":"Case (Pcs)","col6":10,"col7":"","col8":106}},{"id":"b445cc65-12b8-4d76-a5bc-97402ac81248","cols":{"col1":"EI/1","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":104}},{"id":"2cdb3b97-132d-48ed-a4e0-915a11ae7b8a","cols":{"col1":"EI/2","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":102}},{"id":"2f63e976-42dc-43e3-b138-9c4fa85b0631","cols":{"col1":"TI/3","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":100}},{"id":"21d28632-6b94-4d80-b8fe-05816f09a3fe","cols":{"col1":"TI/4","col2":"2018-06-12","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":98}},{"id":"71f9abed-5c4c-4959-945c-f0d6b6ee829c","cols":{"col1":"TI/5","col2":"2018-06-13","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":3,"col8":95}},{"id":"d87b6ef0-3988-42be-80d1-013f126db0a6","cols":{"col1":"TI/6","col2":"2018-06-13","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":1,"col8":94}},{"id":"d7342d30-90ba-4249-8022-4b625e2efcfe","cols":{"col1":"TI/7","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram kumar","col5":"Pcs","col6":"","col7":5,"col8":89}},{"id":"93cfba19-3c70-486b-8468-3f446946d1dd","cols":{"col1":"TI/8","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":2,"col8":87}},{"id":"84955b64-9dc6-441a-a7bf-86bbc0ac97cb","cols":{"col1":"TI/9","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":3,"col8":84}},{"id":"6edc71a9-ee9b-4682-ac2c-67354af41a4f","cols":{"col1":"TI/10","col2":"2018-06-19","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":1,"col8":83}},{"id":"b4a43349-1f30-4722-9e8d-b9b87206356f","cols":{"col1":"DC/1","col2":"2018-06-19","col3":"Delivery Challan","col4":"Ram kumar","col5":"Pcs","col6":"","col7":2,"col8":81}},{"id":"7b20079e-76a6-4744-847c-6ffc7b70d58b","cols":{"col1":"TI/11","col2":"2018-06-27","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":2,"col8":79}},{"id":"ef9a93f1-2733-4bef-939d-86a93d492da7","cols":{"col1":"TI/13","col2":"2018-07-02","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":1,"col8":78}},{"id":"96c7d332-624f-47b7-a107-af49bcb72917","cols":{"col1":"TI/14","col2":"2018-07-02","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":3,"col8":75}},{"id":"c4fd6ed6-7c5d-4030-840d-5bb24a39206d","cols":{"col1":"TI/15","col2":"2018-07-06","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":2,"col8":73}},{"id":"3ed73d3f-708f-4f3d-8646-03d68fa16019","cols":{"col1":"TI/16","col2":"2018-07-06","col3":"Sale Invoice","col4":"Ram","col5":"Pcs","col6":"","col7":5,"col8":68}},{"id":"d7766b55-456c-46fd-82a0-d7d6c6692673","cols":{"col1":"TI/17","col2":"2018-07-12","col3":"Sale Invoice","col4":"Abc","col5":"Pcs","col6":"","col7":10,"col8":58}},{"id":"d7766b55-456c-46fd-82a0-d7d6c6692673","cols":{"col1":"TI/17","col2":"2018-07-12","col3":"Sale Invoice","col4":"Abc","col5":"Case (Pcs)","col6":"","col7":5,"col8":8}}],"footerRow":{"col1":"Total","col2":"","col3":"","col4":"","col5":"","col6":20,"col7":57,"col8":8}

// "headerRow":{"col1":"Vch No.","col2":"Date","col3":"Vch.Type","col4":"Particulars","col5":"Unit","col6":"Inward","col7":"Outward","col8":"Balance","col9":"Vch No.","col10":"Date","col11":"Vch.Type","col12":"Particulars","col13":"Unit","col14":"Inward","col15":"Outward","col16":"Balance","col17":"Vch No.","col18":"Date","col19":"Vch.Type","col20":"Particulars"},"detailRows":[{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}},{"id":"d925781d-6216-4387-bc0e-6317154f5fa7","cols":{"col1":"TI/1","col2":"2018-06-11","col3":"Sale Invoice","col4":"S","col5":"Pcs","col6":"","col7":2,"col8":-2,"col9":"TI/1","col10":"2018-06-11","col11":"Sale Invoice","col12":"S","col13":"Pcs","col14":"","col15":2,"col16":-2,"col17":"TI/1","col18":"2018-06-11","col19":"Sale Invoice","col20":"S"}}],"footerRow":{"col1":"Vch No.","col2":"Date","col3":"Vch.Type","col4":"Particulars","col5":"Unit","col6":"Inward","col7":"Outward","col8":"Balance","col9":"Vch No.","col10":"Date","col11":"Vch.Type","col12":"Particulars","col13":"Unit","col14":"Inward","col15":"Outward","col16":"Balance","col17":"Vch No.","col18":"Date","col19":"Vch.Type","col20":"Particulars"}


// WEBPACK FOOTER //
// src/components/newreports/report_container.vue